export const sample = () => ({
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: [
          [19.042803, 47.516635, 102.4],
          [19.04328, 47.515449, 102.4],
          [19.043294, 47.515433, 102.4],
          [19.04355, 47.515261, 101.8],
          [19.043577, 47.515256, 101.8],
          [19.043894, 47.515402, 101.6],
          [19.043913, 47.515422, 101.5],
          [19.044632, 47.516773, 102.4],
          [19.04464, 47.516788, 102.4],
          [19.047964, 47.521374, 102.5],
          [19.047974, 47.521387, 102.5],
          [19.049976, 47.524489, 102.5],
          [19.049984, 47.524502, 102.5],
          [19.051735, 47.527896, 102.6],
          [19.05175, 47.527928, 102.7],
          [19.053195, 47.531551, 102.7],
          [19.053199, 47.531562, 102.7],
          [19.053684, 47.533288, 103],
          [19.053687, 47.533299, 103],
          [19.054379, 47.536894, 103.1],
          [19.054356, 47.536923, 103.1],
          [19.053257, 47.537128, 103.9],
          [19.053239, 47.537118, 103.8],
          [19.051585, 47.53518, 103],
          [19.051573, 47.535167, 103],
          [19.050195, 47.533948, 103.1],
          [19.050185, 47.533939, 103.1],
          [19.047069, 47.530661, 102.9],
          [19.047042, 47.530629, 102.9],
          [19.04534, 47.528328, 102.9],
          [19.045329, 47.528315, 102.9],
          [19.043736, 47.525656, 102.7],
          [19.043728, 47.525642, 102.7],
          [19.042529, 47.523367, 102.5],
          [19.042522, 47.523353, 102.5],
          [19.042138, 47.522014, 102.6],
          [19.042134, 47.522002, 102.6],
          [19.042082, 47.520892, 102.4],
          [19.042083, 47.520877, 102.4],
          [19.042604, 47.517533, 102.5],
          [19.042607, 47.517518, 102.5],
          [19.042858, 47.517123, 102.4],
          [19.042864, 47.517107, 102.4],
          [19.043294, 47.515621, 102.4],
          [19.043299, 47.51561, 102.4],
          [19.043684, 47.515392, 101.8],
          [19.043701, 47.515389, 101.8],
          [19.044019, 47.515547, 101.3],
          [19.044051, 47.515585, 101.2],
          [19.0453, 47.517746, 102.4],
          [19.045306, 47.517757, 102.4],
          [19.049404, 47.523589, 102.5],
          [19.049414, 47.523603, 102.5],
          [19.051532, 47.527491, 102.6],
          [19.05155, 47.527528, 102.6],
          [19.053228, 47.531697, 102.7],
          [19.05324, 47.531735, 102.7],
          [19.054349, 47.536832, 103.1],
          [19.054335, 47.536871, 103.1],
          [19.05322, 47.537143, 103.8],
          [19.053201, 47.537136, 103.8],
          [19.051653, 47.535287, 103],
          [19.051644, 47.535277, 103],
          [19.047659, 47.531431, 103.1],
          [19.047634, 47.531401, 103.1],
          [19.044536, 47.527122, 103.1],
          [19.044515, 47.52709, 103.1],
          [19.042706, 47.523627, 102.7],
          [19.042699, 47.523616, 102.7],
          [19.042179, 47.5221, 102.5],
          [19.042176, 47.522089, 102.5],
          [19.042097, 47.520926, 102.4],
          [19.042097, 47.520915, 102.4],
          [19.042388, 47.518481, 102.5],
          [19.042387, 47.518469, 102.5],
          [19.043143, 47.516033, 102.3],
          [19.043157, 47.515998, 102.3],
          [19.043345, 47.515586, 102.4],
          [19.043355, 47.515576, 102.4],
          [19.043809, 47.515449, 101.7],
          [19.043834, 47.515454, 101.6],
          [19.044083, 47.515624, 101.2],
          [19.044094, 47.515639, 101.2],
          [19.044444, 47.516453, 102.3],
          [19.044444, 47.516462, 102.3],
          [19.044242, 47.51661, 105.8],
          [19.044224, 47.516612, 106.2],
          [19.044019, 47.516422, 111.5],
          [19.044012, 47.51641, 111.6],
          [19.043608, 47.514914, 117.8],
          [19.043612, 47.514902, 117.9],
          [19.047961, 47.513359, 109.4],
          [19.047981, 47.513348, 109.3],
          [19.047618, 47.51298, 108.7],
          [19.047597, 47.512966, 108.7],
          [19.047028, 47.512816, 107.7],
          [19.04701, 47.512808, 107.7],
          [19.046747, 47.512577, 107.3],
          [19.046738, 47.512568, 107.3],
          [19.046668, 47.511885, 107],
          [19.046664, 47.51187, 107],
          [19.046348, 47.511205, 106.7],
          [19.046343, 47.511188, 106.7],
          [19.046188, 47.510271, 107.1],
          [19.046188, 47.510255, 107.1],
          [19.046677, 47.510004, 108.5],
          [19.046699, 47.510003, 108.5],
          [19.047388, 47.511185, 109]
        ]
      },
      properties: {
        name: 'Sziget Run',
        cmt: null,
        desc: null,
        src: null,
        number: null,
        link: {},
        type: '9'
      }
    }
  ],
  properties: {
    name: null,
    desc: null,
    time: '2021-10-31T14:35:32Z',
    author: {}
  }
});

export const f1circuits = () => ({
  type: 'FeatureCollection',
  name: 'f1-circuits',
  bbox: [-99.09685, -37.853914, 144.978558, 52.391811],
  features: [
    {
      type: 'Feature',
      properties: {
        id: 'au-1953',
        Location: 'Melbourne',
        Name: 'Albert Park Circuit',
        opened: 1953,
        firstgp: 1996,
        length: 5027,
        altitude: 10
      },
      bbox: [144.962151, -37.853914, 144.978558, -37.838006],
      geometry: {
        type: 'LineString',
        coordinates: [
          [144.968644, -37.849757],
          [144.966075, -37.847735],
          [144.966016, -37.847655],
          [144.965998, -37.847593],
          [144.966028, -37.847504],
          [144.966099, -37.84741],
          [144.966164, -37.847287],
          [144.966229, -37.847141],
          [144.966253, -37.846962],
          [144.966253, -37.846811],
          [144.966217, -37.84657],
          [144.96614, -37.846438],
          [144.966034, -37.846292],
          [144.965898, -37.846151],
          [144.964897, -37.845401],
          [144.964264, -37.844874],
          [144.963714, -37.844331],
          [144.963222, -37.843799],
          [144.962796, -37.843266],
          [144.962186, -37.842399],
          [144.962151, -37.842305],
          [144.962157, -37.84221],
          [144.962216, -37.842144],
          [144.962334, -37.842097],
          [144.963495, -37.841923],
          [144.963619, -37.84188],
          [144.96369, -37.841819],
          [144.963743, -37.841744],
          [144.963761, -37.841668],
          [144.963743, -37.841531],
          [144.963696, -37.840033],
          [144.963714, -37.839915],
          [144.963785, -37.839811],
          [144.963873, -37.839717],
          [144.963998, -37.839637],
          [144.96514, -37.838986],
          [144.965501, -37.838831],
          [144.966655, -37.838486],
          [144.967075, -37.838345],
          [144.967431, -37.838194],
          [144.967756, -37.838029],
          [144.967863, -37.838006],
          [144.967957, -37.838024],
          [144.96804, -37.838076],
          [144.968165, -37.83818],
          [144.968378, -37.838307],
          [144.968638, -37.83842],
          [144.968922, -37.838496],
          [144.96923, -37.838529],
          [144.969502, -37.838543],
          [144.96978, -37.838581],
          [144.9701, -37.838656],
          [144.970449, -37.838788],
          [144.970722, -37.838939],
          [144.970958, -37.839132],
          [144.97113, -37.839302],
          [144.971319, -37.839552],
          [144.97142, -37.839736],
          [144.971491, -37.839957],
          [144.971532, -37.84016],
          [144.971976, -37.842064],
          [144.971988, -37.842149],
          [144.971959, -37.842206],
          [144.971911, -37.842248],
          [144.971834, -37.842272],
          [144.971669, -37.842305],
          [144.971461, -37.84238],
          [144.971272, -37.842479],
          [144.971159, -37.842583],
          [144.971065, -37.84271],
          [144.970982, -37.84288],
          [144.970627, -37.844412],
          [144.970609, -37.84461],
          [144.970609, -37.844784],
          [144.970674, -37.845345],
          [144.970757, -37.84559],
          [144.970858, -37.845849],
          [144.971, -37.846132],
          [144.971142, -37.846349],
          [144.971378, -37.846641],
          [144.971615, -37.846882],
          [144.971893, -37.847117],
          [144.972935, -37.847838],
          [144.973095, -37.847933],
          [144.973249, -37.848003],
          [144.973409, -37.848051],
          [144.973586, -37.848084],
          [144.973764, -37.848102],
          [144.973989, -37.848102],
          [144.974255, -37.848093],
          [144.974462, -37.848098],
          [144.974652, -37.848117],
          [144.974829, -37.848154],
          [144.974977, -37.848201],
          [144.975131, -37.848263],
          [144.975279, -37.848343],
          [144.976492, -37.849182],
          [144.976919, -37.849498],
          [144.977114, -37.849658],
          [144.977286, -37.849823],
          [144.977439, -37.850016],
          [144.977605, -37.850308],
          [144.977777, -37.850704],
          [144.978162, -37.85176],
          [144.978529, -37.852788],
          [144.978558, -37.852962],
          [144.97854, -37.853075],
          [144.978463, -37.85316],
          [144.978304, -37.853236],
          [144.976256, -37.853872],
          [144.976037, -37.853914],
          [144.975865, -37.853905],
          [144.975676, -37.853863],
          [144.975516, -37.853787],
          [144.975409, -37.853684],
          [144.975303, -37.853556],
          [144.974551, -37.852467],
          [144.974338, -37.852194],
          [144.974255, -37.852119],
          [144.974202, -37.852081],
          [144.974113, -37.852067],
          [144.974042, -37.852086],
          [144.973953, -37.852137],
          [144.973344, -37.852703],
          [144.973202, -37.852793],
          [144.973024, -37.852844],
          [144.97284, -37.852863],
          [144.972651, -37.852849],
          [144.972462, -37.852783],
          [144.972296, -37.852675],
          [144.968644, -37.849757]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'bh-2002',
        Location: 'Sakhir',
        Name: 'Bahrain International Circuit',
        opened: 2002,
        firstgp: 2004,
        length: 5412,
        altitude: -16
      },
      bbox: [50.510278, 26.026086, 50.518387, 26.036885],
      geometry: {
        type: 'LineString',
        coordinates: [
          [50.510539, 26.031766],
          [50.510633, 26.034797],
          [50.510722, 26.036782],
          [50.510764, 26.036871],
          [50.510852, 26.036885],
          [50.510947, 26.036862],
          [50.511018, 26.036815],
          [50.511474, 26.0364],
          [50.511598, 26.036358],
          [50.511734, 26.036367],
          [50.512527, 26.036598],
          [50.512717, 26.036617],
          [50.512889, 26.036607],
          [50.518091, 26.035702],
          [50.518269, 26.035655],
          [50.518364, 26.035566],
          [50.518387, 26.035452],
          [50.518369, 26.035344],
          [50.51831, 26.035222],
          [50.518198, 26.035099],
          [50.518068, 26.035],
          [50.51789, 26.034877],
          [50.517263, 26.034458],
          [50.516759, 26.033987],
          [50.516635, 26.033878],
          [50.516535, 26.033723],
          [50.51631, 26.033265],
          [50.516233, 26.033166],
          [50.516114, 26.033096],
          [50.515996, 26.033039],
          [50.515807, 26.03302],
          [50.515238, 26.033105],
          [50.515084, 26.0331],
          [50.514925, 26.033072],
          [50.514794, 26.033011],
          [50.514635, 26.032879],
          [50.51348, 26.031564],
          [50.513368, 26.031474],
          [50.513208, 26.031451],
          [50.513108, 26.031521],
          [50.513072, 26.031663],
          [50.513078, 26.031879],
          [50.513356, 26.033369],
          [50.513516, 26.034302],
          [50.51354, 26.034486],
          [50.51351, 26.034656],
          [50.513469, 26.034783],
          [50.513386, 26.03491],
          [50.512912, 26.035278],
          [50.512847, 26.035306],
          [50.512776, 26.035288],
          [50.512735, 26.035222],
          [50.512563, 26.034071],
          [50.512516, 26.033303],
          [50.512433, 26.031922],
          [50.512374, 26.030479],
          [50.512314, 26.029164],
          [50.512338, 26.028948],
          [50.512433, 26.02882],
          [50.512581, 26.02875],
          [50.512788, 26.028712],
          [50.513001, 26.028726],
          [50.513267, 26.028773],
          [50.51354, 26.028891],
          [50.51377, 26.029037],
          [50.513995, 26.029244],
          [50.514132, 26.029447],
          [50.514386, 26.030041],
          [50.514528, 26.030291],
          [50.514664, 26.030437],
          [50.514842, 26.030569],
          [50.515055, 26.030687],
          [50.515351, 26.030753],
          [50.515676, 26.030758],
          [50.515907, 26.03071],
          [50.516215, 26.030578],
          [50.517026, 26.030216],
          [50.517192, 26.030107],
          [50.517334, 26.02998],
          [50.517405, 26.029862],
          [50.517493, 26.02973],
          [50.517493, 26.029612],
          [50.517422, 26.02949],
          [50.51728, 26.029367],
          [50.517085, 26.029235],
          [50.510941, 26.026143],
          [50.510829, 26.026091],
          [50.510651, 26.026086],
          [50.510574, 26.026152],
          [50.510302, 26.026671],
          [50.510278, 26.026878],
          [50.510284, 26.027269],
          [50.510361, 26.029414],
          [50.510539, 26.031766]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'cn-2004',
        Location: 'Shanghai',
        Name: 'Shanghai International Circuit',
        opened: 2004,
        firstgp: 2004,
        length: 5451,
        altitude: 14
      },
      bbox: [121.214959, 31.335826, 121.227856, 31.345484],
      geometry: {
        type: 'LineString',
        coordinates: [
          [121.21838, 31.336835],
          [121.217409, 31.336627],
          [121.217232, 31.336613],
          [121.217019, 31.336613],
          [121.216829, 31.336665],
          [121.216699, 31.336712],
          [121.216527, 31.336806],
          [121.216403, 31.336901],
          [121.216308, 31.337009],
          [121.216237, 31.337136],
          [121.216178, 31.337264],
          [121.216172, 31.3374],
          [121.216178, 31.337556],
          [121.216202, 31.337674],
          [121.216243, 31.337787],
          [121.21632, 31.337886],
          [121.216427, 31.337971],
          [121.216664, 31.33806],
          [121.216883, 31.33806],
          [121.217054, 31.338004],
          [121.217125, 31.337938],
          [121.217173, 31.337867],
          [121.217178, 31.337768],
          [121.217143, 31.337627],
          [121.217072, 31.337415],
          [121.217054, 31.337325],
          [121.217096, 31.337235],
          [121.217196, 31.337141],
          [121.217368, 31.337085],
          [121.217557, 31.337118],
          [121.217658, 31.337174],
          [121.217723, 31.337268],
          [121.217782, 31.337363],
          [121.217841, 31.33749],
          [121.217877, 31.337631],
          [121.217889, 31.337792],
          [121.217859, 31.337928],
          [121.217764, 31.338079],
          [121.217699, 31.338173],
          [121.217504, 31.338376],
          [121.216983, 31.338852],
          [121.216581, 31.3393],
          [121.216249, 31.339606],
          [121.215835, 31.340007],
          [121.215705, 31.340196],
          [121.215645, 31.340332],
          [121.215219, 31.341402],
          [121.215083, 31.341723],
          [121.214965, 31.342039],
          [121.214959, 31.342119],
          [121.215012, 31.342185],
          [121.215119, 31.342223],
          [121.215302, 31.342194],
          [121.215492, 31.342086],
          [121.215651, 31.341973],
          [121.215811, 31.341827],
          [121.216036, 31.341629],
          [121.216231, 31.341384],
          [121.216575, 31.34087],
          [121.217036, 31.340177],
          [121.217184, 31.339984],
          [121.217332, 31.339833],
          [121.217498, 31.339696],
          [121.217693, 31.339606],
          [121.217901, 31.33954],
          [121.218114, 31.339503],
          [121.218362, 31.339503],
          [121.218581, 31.33954],
          [121.218794, 31.339606],
          [121.219007, 31.33972],
          [121.219209, 31.339861],
          [121.219368, 31.340021],
          [121.21954, 31.340337],
          [121.219806, 31.340818],
          [121.219919, 31.340964],
          [121.220037, 31.341063],
          [121.220185, 31.341138],
          [121.220404, 31.341219],
          [121.220611, 31.341233],
          [121.220789, 31.341219],
          [121.220949, 31.341167],
          [121.221091, 31.341087],
          [121.221191, 31.341016],
          [121.22128, 31.340931],
          [121.221718, 31.340205],
          [121.221825, 31.340106],
          [121.221955, 31.340073],
          [121.222079, 31.340092],
          [121.222192, 31.34013],
          [121.22263, 31.340625],
          [121.222689, 31.340724],
          [121.222689, 31.340813],
          [121.222653, 31.340903],
          [121.221582, 31.342458],
          [121.220913, 31.343382],
          [121.220179, 31.344419],
          [121.220079, 31.344447],
          [121.219978, 31.344424],
          [121.219883, 31.344353],
          [121.219771, 31.344245],
          [121.219664, 31.344132],
          [121.219564, 31.344075],
          [121.219439, 31.344042],
          [121.219309, 31.344061],
          [121.219179, 31.34416],
          [121.219025, 31.344306],
          [121.218948, 31.344424],
          [121.218901, 31.344532],
          [121.218877, 31.344693],
          [121.218889, 31.344839],
          [121.218919, 31.34498],
          [121.218972, 31.345112],
          [121.219114, 31.345272],
          [121.21925, 31.345362],
          [121.219439, 31.345433],
          [121.219641, 31.34547],
          [121.219801, 31.345484],
          [121.219996, 31.345475],
          [121.22025, 31.345423],
          [121.220416, 31.345362],
          [121.220588, 31.345282],
          [121.220824, 31.345093],
          [121.221032, 31.344843],
          [121.223281, 31.341902],
          [121.224684, 31.340092],
          [121.225412, 31.339149],
          [121.226051, 31.338296],
          [121.226897, 31.337217],
          [121.227803, 31.336085],
          [121.227856, 31.335986],
          [121.22785, 31.335892],
          [121.227773, 31.335826],
          [121.227649, 31.335835],
          [121.227394, 31.335939],
          [121.227246, 31.336029],
          [121.227081, 31.336132],
          [121.225347, 31.338155],
          [121.22527, 31.338192],
          [121.225128, 31.338202],
          [121.222955, 31.337763],
          [121.21838, 31.336835]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'az-2016',
        Location: 'Baku',
        Name: 'Baku City Circuit',
        opened: 2016,
        firstgp: 2016,
        length: 6003,
        altitude: -25
      },
      bbox: [49.830927, 40.362639, 49.855189, 40.376148],
      geometry: {
        type: 'LineString',
        coordinates: [
          [49.853247, 40.372688],
          [49.851442, 40.372113],
          [49.848684, 40.371218],
          [49.847606, 40.370845],
          [49.844949, 40.369978],
          [49.84386, 40.369591],
          [49.842635, 40.3692],
          [49.84225, 40.369059],
          [49.841836, 40.368889],
          [49.841469, 40.368705],
          [49.838752, 40.367098],
          [49.838586, 40.366985],
          [49.838444, 40.366824],
          [49.838373, 40.366655],
          [49.838207, 40.365792],
          [49.83813, 40.365632],
          [49.837976, 40.365467],
          [49.836088, 40.364156],
          [49.835911, 40.363982],
          [49.835757, 40.363765],
          [49.835094, 40.362832],
          [49.834993, 40.362747],
          [49.834839, 40.362667],
          [49.83462, 40.362639],
          [49.834431, 40.362662],
          [49.834094, 40.362756],
          [49.833478, 40.362964],
          [49.831282, 40.363841],
          [49.831152, 40.363958],
          [49.831099, 40.364076],
          [49.830927, 40.365957],
          [49.830963, 40.366141],
          [49.831489, 40.367503],
          [49.831643, 40.367744],
          [49.831809, 40.367913],
          [49.832022, 40.368045],
          [49.833093, 40.368535],
          [49.834715, 40.369139],
          [49.835733, 40.369408],
          [49.835875, 40.369403],
          [49.83597, 40.369356],
          [49.836035, 40.369294],
          [49.836171, 40.368955],
          [49.836248, 40.368865],
          [49.836402, 40.368818],
          [49.836544, 40.368828],
          [49.836692, 40.368832],
          [49.836834, 40.368804],
          [49.837065, 40.368696],
          [49.837219, 40.368696],
          [49.837337, 40.368677],
          [49.837414, 40.368616],
          [49.838053, 40.367183],
          [49.838195, 40.367065],
          [49.838367, 40.36706],
          [49.838539, 40.36715],
          [49.838947, 40.367432],
          [49.841362, 40.368856],
          [49.841764, 40.369125],
          [49.841853, 40.369191],
          [49.841859, 40.369276],
          [49.841682, 40.369572],
          [49.841658, 40.369667],
          [49.841723, 40.369733],
          [49.842783, 40.370251],
          [49.84357, 40.370581],
          [49.844961, 40.371081],
          [49.845085, 40.371189],
          [49.845079, 40.371312],
          [49.84428, 40.372891],
          [49.84428, 40.373065],
          [49.84444, 40.373193],
          [49.846884, 40.374046],
          [49.849719, 40.375017],
          [49.851797, 40.37563],
          [49.853496, 40.376148],
          [49.853602, 40.376134],
          [49.853685, 40.376092],
          [49.854188, 40.37522],
          [49.854798, 40.374319],
          [49.855159, 40.373607],
          [49.855189, 40.37349],
          [49.855177, 40.373409],
          [49.855117, 40.373325],
          [49.855023, 40.373268],
          [49.853247, 40.372688]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'es-1991',
        Location: 'Barcelona',
        Name: 'Circuit de Barcelona-Catalunya',
        opened: 1991,
        firstgp: 1991,
        length: 4655,
        altitude: 165
      },
      bbox: [2.252175, 41.564187, 2.263729, 41.574661],
      geometry: {
        type: 'LineString',
        coordinates: [
          [2.261284, 41.570051],
          [2.25981, 41.568288],
          [2.25894, 41.56726],
          [2.258064, 41.566219],
          [2.257106, 41.565087],
          [2.256875, 41.5648],
          [2.25678, 41.56471],
          [2.25665, 41.564663],
          [2.256508, 41.564635],
          [2.256378, 41.56463],
          [2.256283, 41.564644],
          [2.2562, 41.564668],
          [2.256034, 41.564753],
          [2.255851, 41.564837],
          [2.255703, 41.56488],
          [2.255549, 41.564894],
          [2.255407, 41.564894],
          [2.255265, 41.564866],
          [2.255111, 41.564795],
          [2.254448, 41.564437],
          [2.254217, 41.564314],
          [2.254028, 41.564248],
          [2.25385, 41.564215],
          [2.253696, 41.564196],
          [2.253525, 41.564187],
          [2.253377, 41.564201],
          [2.253164, 41.564229],
          [2.252986, 41.564281],
          [2.25285, 41.564343],
          [2.252732, 41.564409],
          [2.252625, 41.564484],
          [2.252518, 41.564574],
          [2.25243, 41.564687],
          [2.252341, 41.564795],
          [2.252258, 41.564955],
          [2.252199, 41.565144],
          [2.252175, 41.565328],
          [2.252193, 41.565535],
          [2.25224, 41.565771],
          [2.252305, 41.565978],
          [2.252406, 41.566204],
          [2.252542, 41.566393],
          [2.252761, 41.566681],
          [2.254046, 41.568198],
          [2.254134, 41.568279],
          [2.254247, 41.568349],
          [2.254401, 41.56841],
          [2.254572, 41.568434],
          [2.254768, 41.56842],
          [2.254975, 41.568354],
          [2.255146, 41.56825],
          [2.255271, 41.568128],
          [2.255359, 41.568],
          [2.255407, 41.567859],
          [2.255431, 41.567685],
          [2.255413, 41.567524],
          [2.255365, 41.567369],
          [2.255294, 41.567223],
          [2.255206, 41.567109],
          [2.254152, 41.56587],
          [2.254057, 41.565747],
          [2.254016, 41.565639],
          [2.254051, 41.565521],
          [2.254111, 41.565431],
          [2.254253, 41.565342],
          [2.254383, 41.565299],
          [2.254537, 41.565299],
          [2.254679, 41.565342],
          [2.25623, 41.565879],
          [2.256437, 41.565969],
          [2.256608, 41.566068],
          [2.256851, 41.566228],
          [2.257117, 41.56645],
          [2.257721, 41.567157],
          [2.257816, 41.567284],
          [2.257851, 41.567392],
          [2.257822, 41.567515],
          [2.257733, 41.567619],
          [2.257603, 41.567708],
          [2.257425, 41.567793],
          [2.257248, 41.567878],
          [2.257117, 41.567977],
          [2.256993, 41.568099],
          [2.256916, 41.568227],
          [2.256502, 41.568938],
          [2.256076, 41.569693],
          [2.25604, 41.56982],
          [2.256022, 41.56999],
          [2.25604, 41.570122],
          [2.256088, 41.570249],
          [2.25617, 41.570362],
          [2.256271, 41.57047],
          [2.256407, 41.570574],
          [2.256591, 41.570678],
          [2.261906, 41.572705],
          [2.261959, 41.572742],
          [2.262, 41.572804],
          [2.262006, 41.572874],
          [2.261971, 41.572945],
          [2.261924, 41.572983],
          [2.261805, 41.573025],
          [2.260675, 41.573204],
          [2.260544, 41.573223],
          [2.260432, 41.573204],
          [2.260089, 41.573002],
          [2.259911, 41.572912],
          [2.259722, 41.57287],
          [2.259532, 41.57287],
          [2.259331, 41.572912],
          [2.259177, 41.572978],
          [2.259047, 41.573082],
          [2.25897, 41.573209],
          [2.258923, 41.573346],
          [2.258934, 41.573487],
          [2.258994, 41.573619],
          [2.259088, 41.573718],
          [2.25923, 41.573812],
          [2.260432, 41.574567],
          [2.26055, 41.574633],
          [2.260675, 41.574661],
          [2.260811, 41.574637],
          [2.260935, 41.574581],
          [2.261805, 41.574076],
          [2.261906, 41.57402],
          [2.262024, 41.57402],
          [2.262131, 41.574058],
          [2.262296, 41.574194],
          [2.262385, 41.574237],
          [2.262521, 41.574208],
          [2.263232, 41.573869],
          [2.263433, 41.573742],
          [2.263575, 41.57361],
          [2.263658, 41.573487],
          [2.263723, 41.573341],
          [2.263729, 41.573181],
          [2.263711, 41.573006],
          [2.263616, 41.572813],
          [2.261284, 41.570051]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'mc-1929',
        Location: 'Monte Carlo',
        Name: 'Circuit de Monaco',
        opened: 1929,
        firstgp: 1929,
        length: 3337,
        altitude: 47
      },
      bbox: [7.421216, 43.732365, 7.430355, 43.741099],
      geometry: {
        type: 'LineString',
        coordinates: [
          [7.427135, 43.73944],
          [7.427135, 43.739511],
          [7.427159, 43.739582],
          [7.427206, 43.739652],
          [7.427259, 43.739728],
          [7.42736, 43.739836],
          [7.428662, 43.741052],
          [7.428745, 43.74109],
          [7.428857, 43.741095],
          [7.42897, 43.741062],
          [7.429053, 43.741],
          [7.429082, 43.740944],
          [7.4291, 43.740864],
          [7.429106, 43.740765],
          [7.429135, 43.740694],
          [7.429195, 43.740614],
          [7.42926, 43.740553],
          [7.429372, 43.740425],
          [7.429449, 43.740289],
          [7.429496, 43.740241],
          [7.429585, 43.740204],
          [7.429668, 43.740218],
          [7.429721, 43.740251],
          [7.429739, 43.740317],
          [7.429727, 43.740359],
          [7.429692, 43.740397],
          [7.429508, 43.74051],
          [7.429343, 43.74068],
          [7.429307, 43.740741],
          [7.429295, 43.740802],
          [7.429319, 43.740845],
          [7.429384, 43.740897],
          [7.429437, 43.74093],
          [7.429704, 43.741],
          [7.430023, 43.74109],
          [7.430153, 43.741099],
          [7.430236, 43.74108],
          [7.430296, 43.741052],
          [7.430331, 43.74101],
          [7.430355, 43.740958],
          [7.430331, 43.740359],
          [7.430088, 43.739737],
          [7.429952, 43.739421],
          [7.429739, 43.739115],
          [7.429508, 43.738813],
          [7.429206, 43.738516],
          [7.42878, 43.7382],
          [7.428313, 43.737922],
          [7.42791, 43.737743],
          [7.427472, 43.737588],
          [7.427052, 43.737474],
          [7.426182, 43.737314],
          [7.425714, 43.737262],
          [7.425596, 43.737234],
          [7.425531, 43.737201],
          [7.425489, 43.737149],
          [7.425442, 43.737083],
          [7.425389, 43.737055],
          [7.425217, 43.737036],
          [7.42514, 43.737036],
          [7.424998, 43.737074],
          [7.424898, 43.737079],
          [7.42369, 43.736937],
          [7.42256, 43.736824],
          [7.422406, 43.73681],
          [7.422293, 43.736791],
          [7.422193, 43.736749],
          [7.422104, 43.736673],
          [7.422021, 43.736536],
          [7.421926, 43.736376],
          [7.421843, 43.736202],
          [7.421784, 43.735994],
          [7.421766, 43.735806],
          [7.421778, 43.735547],
          [7.421832, 43.735339],
          [7.421891, 43.735254],
          [7.422157, 43.73508],
          [7.422228, 43.735],
          [7.422412, 43.734312],
          [7.422406, 43.734246],
          [7.422358, 43.734194],
          [7.422299, 43.734151],
          [7.422228, 43.734085],
          [7.422199, 43.734024],
          [7.422199, 43.733944],
          [7.422423, 43.733435],
          [7.422607, 43.73318],
          [7.422909, 43.732916],
          [7.423057, 43.732841],
          [7.423193, 43.732789],
          [7.423341, 43.732742],
          [7.423447, 43.732652],
          [7.423471, 43.732563],
          [7.423465, 43.732516],
          [7.423412, 43.732473],
          [7.423234, 43.732435],
          [7.423021, 43.732398],
          [7.422784, 43.732365],
          [7.422631, 43.732369],
          [7.422512, 43.732402],
          [7.422459, 43.732445],
          [7.422429, 43.732478],
          [7.422418, 43.732534],
          [7.4224, 43.7326],
          [7.422364, 43.732681],
          [7.422074, 43.732982],
          [7.421873, 43.733298],
          [7.421725, 43.733595],
          [7.421465, 43.73434],
          [7.421376, 43.734703],
          [7.421293, 43.73507],
          [7.421216, 43.735735],
          [7.421234, 43.735966],
          [7.421305, 43.736211],
          [7.421382, 43.736452],
          [7.421417, 43.73656],
          [7.421441, 43.736683],
          [7.421417, 43.736824],
          [7.421441, 43.736895],
          [7.4215, 43.736956],
          [7.421613, 43.736994],
          [7.421737, 43.737008],
          [7.422222, 43.737036],
          [7.422654, 43.737088],
          [7.422974, 43.73714],
          [7.423767, 43.737314],
          [7.424098, 43.737375],
          [7.424406, 43.737418],
          [7.424785, 43.737456],
          [7.42504, 43.737517],
          [7.425714, 43.737767],
          [7.425957, 43.737819],
          [7.426354, 43.737885],
          [7.426726, 43.737927],
          [7.42704, 43.737969],
          [7.427259, 43.73804],
          [7.427472, 43.738163],
          [7.427614, 43.738271],
          [7.427727, 43.738384],
          [7.427786, 43.738493],
          [7.427786, 43.738625],
          [7.42775, 43.738738],
          [7.427703, 43.738841],
          [7.42762, 43.738964],
          [7.427526, 43.739082],
          [7.427419, 43.739171],
          [7.427301, 43.739256],
          [7.427182, 43.739346],
          [7.427135, 43.73944]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'ca-1978',
        Location: 'Montreal',
        Name: 'Circuit Gilles-Villeneuve',
        opened: 1978,
        firstgp: 1978,
        length: 4361,
        altitude: 13
      },
      bbox: [-73.52994, 45.49706, -73.521949, 45.514298],
      geometry: {
        type: 'LineString',
        coordinates: [
          [-73.523246, 45.501816],
          [-73.522944, 45.500831],
          [-73.522719, 45.500105],
          [-73.522594, 45.499568],
          [-73.522577, 45.499125],
          [-73.522772, 45.497937],
          [-73.522736, 45.497795],
          [-73.5226, 45.497706],
          [-73.522097, 45.49755],
          [-73.521997, 45.497498],
          [-73.521949, 45.497395],
          [-73.521967, 45.497291],
          [-73.522038, 45.497187],
          [-73.522174, 45.497107],
          [-73.522346, 45.49706],
          [-73.522571, 45.49706],
          [-73.522819, 45.497098],
          [-73.523411, 45.497215],
          [-73.523814, 45.49731],
          [-73.524198, 45.497456],
          [-73.524565, 45.497626],
          [-73.525412, 45.498135],
          [-73.525915, 45.498465],
          [-73.52601, 45.498568],
          [-73.526033, 45.498653],
          [-73.526027, 45.498738],
          [-73.525939, 45.498927],
          [-73.525909, 45.499044],
          [-73.525927, 45.499139],
          [-73.525986, 45.499219],
          [-73.526951, 45.500044],
          [-73.527122, 45.500147],
          [-73.527448, 45.500308],
          [-73.527643, 45.500421],
          [-73.527856, 45.500619],
          [-73.527975, 45.500831],
          [-73.528058, 45.501048],
          [-73.528087, 45.501222],
          [-73.528081, 45.502509],
          [-73.528081, 45.502617],
          [-73.528146, 45.502702],
          [-73.528265, 45.502768],
          [-73.528472, 45.502801],
          [-73.52875, 45.502754],
          [-73.52891, 45.50274],
          [-73.529105, 45.502778],
          [-73.529271, 45.502853],
          [-73.529389, 45.502933],
          [-73.529496, 45.503032],
          [-73.529561, 45.503122],
          [-73.52965, 45.503301],
          [-73.529727, 45.503522],
          [-73.529815, 45.503796],
          [-73.529827, 45.504027],
          [-73.52994, 45.505012],
          [-73.529928, 45.505545],
          [-73.52991, 45.505974],
          [-73.529857, 45.506445],
          [-73.529786, 45.506817],
          [-73.529715, 45.50711],
          [-73.529218, 45.508514],
          [-73.529135, 45.508642],
          [-73.529016, 45.508693],
          [-73.528892, 45.508712],
          [-73.528709, 45.508722],
          [-73.528567, 45.508755],
          [-73.52843, 45.508811],
          [-73.528282, 45.50892],
          [-73.52817, 45.509047],
          [-73.528069, 45.509221],
          [-73.527578, 45.510621],
          [-73.527383, 45.51138],
          [-73.527318, 45.511913],
          [-73.527288, 45.51246],
          [-73.527294, 45.512639],
          [-73.527324, 45.512827],
          [-73.527685, 45.514072],
          [-73.527697, 45.514147],
          [-73.527685, 45.514213],
          [-73.527602, 45.514279],
          [-73.527442, 45.514298],
          [-73.527341, 45.514274],
          [-73.52727, 45.514218],
          [-73.527247, 45.514171],
          [-73.527205, 45.513893],
          [-73.527146, 45.513468],
          [-73.527122, 45.513327],
          [-73.527045, 45.513171],
          [-73.526785, 45.512799],
          [-73.526554, 45.512469],
          [-73.525388, 45.510357],
          [-73.525252, 45.510084],
          [-73.523524, 45.504286],
          [-73.523453, 45.504046],
          [-73.52347, 45.503966],
          [-73.523547, 45.503904],
          [-73.523684, 45.503867],
          [-73.523772, 45.503805],
          [-73.523808, 45.503735],
          [-73.523802, 45.503645],
          [-73.523488, 45.502641],
          [-73.523246, 45.501816]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'fr-1969',
        Location: 'Le Castellet',
        Name: 'Circuit Paul Ricard',
        opened: 1969,
        firstgp: 1971,
        length: 5842,
        altitude: 408
      },
      bbox: [5.778164, 43.247028, 5.803728, 43.258652],
      geometry: {
        type: 'LineString',
        coordinates: [
          [5.791571, 43.25202],
          [5.794542, 43.25037],
          [5.796057, 43.249517],
          [5.796152, 43.249493],
          [5.796241, 43.249498],
          [5.796312, 43.249526],
          [5.796353, 43.249569],
          [5.796371, 43.249625],
          [5.796395, 43.250205],
          [5.796418, 43.250327],
          [5.796454, 43.250393],
          [5.796519, 43.250464],
          [5.79662, 43.250554],
          [5.796762, 43.250643],
          [5.796927, 43.250709],
          [5.797105, 43.250747],
          [5.797288, 43.250756],
          [5.797496, 43.250747],
          [5.797685, 43.2507],
          [5.797833, 43.250634],
          [5.797957, 43.250549],
          [5.798194, 43.25036],
          [5.798425, 43.250205],
          [5.798691, 43.250059],
          [5.798975, 43.249941],
          [5.799253, 43.249851],
          [5.799549, 43.24979],
          [5.799839, 43.249743],
          [5.800171, 43.249724],
          [5.80052, 43.249724],
          [5.800798, 43.249752],
          [5.801071, 43.2498],
          [5.801343, 43.249866],
          [5.801615, 43.249946],
          [5.801846, 43.25004],
          [5.801994, 43.250106],
          [5.802124, 43.250153],
          [5.802248, 43.250181],
          [5.802373, 43.250186],
          [5.802503, 43.250167],
          [5.802627, 43.250115],
          [5.802734, 43.250045],
          [5.802805, 43.249974],
          [5.802846, 43.249903],
          [5.802882, 43.249818],
          [5.802905, 43.249701],
          [5.802905, 43.249554],
          [5.80287, 43.249446],
          [5.802817, 43.249342],
          [5.80274, 43.249234],
          [5.802669, 43.249158],
          [5.8021, 43.248616],
          [5.801911, 43.248423],
          [5.801728, 43.248211],
          [5.801544, 43.247961],
          [5.801461, 43.247815],
          [5.801426, 43.247726],
          [5.801408, 43.247641],
          [5.801426, 43.247556],
          [5.801467, 43.24748],
          [5.801526, 43.247405],
          [5.801627, 43.247315],
          [5.801757, 43.247235],
          [5.801935, 43.247146],
          [5.802118, 43.24708],
          [5.802302, 43.247042],
          [5.802467, 43.247028],
          [5.802633, 43.247033],
          [5.802805, 43.247061],
          [5.802965, 43.247103],
          [5.803124, 43.247155],
          [5.803243, 43.247212],
          [5.803349, 43.247273],
          [5.803438, 43.247348],
          [5.803533, 43.247433],
          [5.80361, 43.247542],
          [5.803669, 43.247631],
          [5.803704, 43.24773],
          [5.803722, 43.247829],
          [5.803728, 43.247919],
          [5.803716, 43.249894],
          [5.803716, 43.250031],
          [5.803704, 43.250134],
          [5.803681, 43.250229],
          [5.803622, 43.25036],
          [5.803556, 43.250497],
          [5.80348, 43.250601],
          [5.803379, 43.250709],
          [5.803249, 43.250818],
          [5.803101, 43.250931],
          [5.802941, 43.251025],
          [5.802799, 43.251096],
          [5.802663, 43.251148],
          [5.802532, 43.25119],
          [5.801467, 43.251492],
          [5.8002, 43.251841],
          [5.798981, 43.252171],
          [5.797531, 43.252562],
          [5.796241, 43.25292],
          [5.796081, 43.252972],
          [5.795933, 43.253033],
          [5.79485, 43.253575],
          [5.794654, 43.253674],
          [5.79456, 43.25375],
          [5.794252, 43.254094],
          [5.794169, 43.25415],
          [5.794051, 43.254202],
          [5.793932, 43.254216],
          [5.793844, 43.254216],
          [5.793749, 43.254183],
          [5.793672, 43.254141],
          [5.793258, 43.253858],
          [5.793169, 43.253811],
          [5.793068, 43.253797],
          [5.792962, 43.253811],
          [5.791784, 43.254131],
          [5.788061, 43.255145],
          [5.786557, 43.25556],
          [5.782065, 43.256781],
          [5.781017, 43.257068],
          [5.780911, 43.257106],
          [5.780822, 43.257158],
          [5.780775, 43.257205],
          [5.780721, 43.257261],
          [5.780662, 43.257332],
          [5.780621, 43.257403],
          [5.780384, 43.257813],
          [5.780319, 43.257893],
          [5.780254, 43.257983],
          [5.780153, 43.258077],
          [5.780059, 43.258181],
          [5.779964, 43.258256],
          [5.77978, 43.258379],
          [5.779603, 43.258482],
          [5.779443, 43.258553],
          [5.779259, 43.25861],
          [5.779094, 43.258643],
          [5.778987, 43.258652],
          [5.778869, 43.258638],
          [5.77875, 43.25861],
          [5.778656, 43.258567],
          [5.778561, 43.258506],
          [5.778508, 43.258459],
          [5.778472, 43.258397],
          [5.778194, 43.257799],
          [5.778164, 43.257719],
          [5.778164, 43.257681],
          [5.778188, 43.257629],
          [5.778241, 43.257591],
          [5.778324, 43.257573],
          [5.778484, 43.257577],
          [5.77904, 43.257643],
          [5.7792, 43.257643],
          [5.77936, 43.257629],
          [5.779496, 43.257587],
          [5.779591, 43.25753],
          [5.779674, 43.257464],
          [5.779721, 43.257403],
          [5.779768, 43.257323],
          [5.779786, 43.257257],
          [5.779792, 43.2572],
          [5.77978, 43.257125],
          [5.779727, 43.256894],
          [5.779727, 43.256837],
          [5.779745, 43.256776],
          [5.77978, 43.256719],
          [5.779851, 43.256672],
          [5.779958, 43.256606],
          [5.780597, 43.256328],
          [5.781118, 43.256116],
          [5.781591, 43.25597],
          [5.782006, 43.255843],
          [5.782219, 43.255762],
          [5.78245, 43.255673],
          [5.782698, 43.25555],
          [5.783024, 43.25539],
          [5.783456, 43.255136],
          [5.783799, 43.254952],
          [5.784012, 43.254796],
          [5.784302, 43.254575],
          [5.784427, 43.254509],
          [5.784598, 43.254438],
          [5.785238, 43.254179],
          [5.785433, 43.254122],
          [5.785587, 43.254113],
          [5.785729, 43.254127],
          [5.785871, 43.254164],
          [5.786001, 43.254226],
          [5.78609, 43.254292],
          [5.786185, 43.254386],
          [5.786267, 43.254461],
          [5.786374, 43.254523],
          [5.78648, 43.254551],
          [5.786599, 43.254565],
          [5.786753, 43.254565],
          [5.786913, 43.254556],
          [5.787055, 43.254523],
          [5.787143, 43.25448],
          [5.787783, 43.254122],
          [5.788629, 43.253646],
          [5.789588, 43.253132],
          [5.790511, 43.252609],
          [5.791571, 43.25202]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'at-1969',
        Location: 'Spielberg',
        Name: 'Red Bull Ring',
        opened: 1969,
        firstgp: 1970,
        length: 4318,
        altitude: 721
      },
      bbox: [14.754069, 47.219284, 14.770648, 47.226388],
      geometry: {
        type: 'LineString',
        coordinates: [
          [14.765119, 47.220023],
          [14.763977, 47.219817],
          [14.761148, 47.219294],
          [14.760953, 47.219284],
          [14.760823, 47.219364],
          [14.760604, 47.219652],
          [14.759911, 47.220288],
          [14.759159, 47.221014],
          [14.758568, 47.221655],
          [14.758029, 47.222287],
          [14.757147, 47.223593],
          [14.756904, 47.223941],
          [14.756531, 47.224351],
          [14.755957, 47.224828],
          [14.755004, 47.225478],
          [14.754122, 47.226077],
          [14.754069, 47.226157],
          [14.754075, 47.226242],
          [14.754176, 47.226284],
          [14.754407, 47.226312],
          [14.755129, 47.226369],
          [14.755851, 47.226388],
          [14.756597, 47.226383],
          [14.757307, 47.226336],
          [14.75813, 47.226246],
          [14.760645, 47.225916],
          [14.761793, 47.225813],
          [14.764273, 47.225742],
          [14.764475, 47.225695],
          [14.764599, 47.225601],
          [14.764646, 47.225497],
          [14.764634, 47.225388],
          [14.764569, 47.225285],
          [14.764321, 47.225044],
          [14.764125, 47.224884],
          [14.763764, 47.224667],
          [14.763368, 47.224521],
          [14.762888, 47.224413],
          [14.762367, 47.224356],
          [14.761823, 47.22438],
          [14.75971, 47.224611],
          [14.759426, 47.224587],
          [14.759195, 47.224531],
          [14.758994, 47.224436],
          [14.758816, 47.224309],
          [14.758704, 47.224158],
          [14.758644, 47.223993],
          [14.758633, 47.223842],
          [14.758668, 47.223677],
          [14.758733, 47.223555],
          [14.759757, 47.222339],
          [14.759929, 47.222211],
          [14.760201, 47.222094],
          [14.760515, 47.222046],
          [14.760817, 47.222065],
          [14.761136, 47.222155],
          [14.761332, 47.222263],
          [14.761533, 47.222433],
          [14.761722, 47.222598],
          [14.761924, 47.222739],
          [14.762166, 47.222852],
          [14.76245, 47.222966],
          [14.762847, 47.223065],
          [14.763261, 47.223126],
          [14.76654, 47.223173],
          [14.769062, 47.223215],
          [14.769328, 47.223211],
          [14.769588, 47.223149],
          [14.769802, 47.223041],
          [14.769973, 47.222895],
          [14.770103, 47.222702],
          [14.770618, 47.221523],
          [14.770648, 47.221415],
          [14.770618, 47.221335],
          [14.770559, 47.221273],
          [14.770358, 47.221165],
          [14.770092, 47.221057],
          [14.769748, 47.220939],
          [14.769358, 47.220826],
          [14.768896, 47.220722],
          [14.765119, 47.220023]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'gb-1948',
        Location: 'Silverstone',
        Name: 'Silverstone Circuit',
        opened: 1948,
        firstgp: 1950,
        length: 5891,
        altitude: 196
      },
      bbox: [-1.024286, 52.063513, -1.009264, 52.078936],
      geometry: {
        type: 'LineString',
        coordinates: [
          [-1.015349, 52.07879],
          [-1.01262, 52.078936],
          [-1.012135, 52.078918],
          [-1.011762, 52.078842],
          [-1.011519, 52.078743],
          [-1.011229, 52.078536],
          [-1.011046, 52.0783],
          [-1.010898, 52.078003],
          [-1.01069, 52.077499],
          [-1.010477, 52.077004],
          [-1.010353, 52.076457],
          [-1.0103, 52.076113],
          [-1.010229, 52.075279],
          [-1.010199, 52.074567],
          [-1.010152, 52.074289],
          [-1.00998, 52.074029],
          [-1.009655, 52.073666],
          [-1.009518, 52.073459],
          [-1.009524, 52.073303],
          [-1.009584, 52.07312],
          [-1.010045, 52.07237],
          [-1.010075, 52.072068],
          [-1.010004, 52.071852],
          [-1.009838, 52.071668],
          [-1.009382, 52.071277],
          [-1.009276, 52.071097],
          [-1.009264, 52.070885],
          [-1.009341, 52.070692],
          [-1.009619, 52.07048],
          [-1.009974, 52.070324],
          [-1.01046, 52.07015],
          [-1.010838, 52.070013],
          [-1.011105, 52.069853],
          [-1.011412, 52.069537],
          [-1.012016, 52.06884],
          [-1.015337, 52.065083],
          [-1.016426, 52.064041],
          [-1.016734, 52.063786],
          [-1.016982, 52.06365],
          [-1.017272, 52.06356],
          [-1.017574, 52.063513],
          [-1.017852, 52.063527],
          [-1.01816, 52.06357],
          [-1.01842, 52.06364],
          [-1.018651, 52.063753],
          [-1.018847, 52.063933],
          [-1.018906, 52.064003],
          [-1.019202, 52.064399],
          [-1.019533, 52.064753],
          [-1.019888, 52.065045],
          [-1.020131, 52.065224],
          [-1.020403, 52.065408],
          [-1.020883, 52.06571],
          [-1.021954, 52.066497],
          [-1.022061, 52.066539],
          [-1.022209, 52.066549],
          [-1.022356, 52.066506],
          [-1.022806, 52.066256],
          [-1.02296, 52.066223],
          [-1.023114, 52.066233],
          [-1.023244, 52.066266],
          [-1.023428, 52.066374],
          [-1.023623, 52.066497],
          [-1.023866, 52.066695],
          [-1.024043, 52.066907],
          [-1.024168, 52.067124],
          [-1.024274, 52.067369],
          [-1.024286, 52.067468],
          [-1.024256, 52.067567],
          [-1.024168, 52.067661],
          [-1.023955, 52.067869],
          [-1.020687, 52.070489],
          [-1.019953, 52.071069],
          [-1.0198, 52.071178],
          [-1.019533, 52.071286],
          [-1.019214, 52.071333],
          [-1.018953, 52.071338],
          [-1.018592, 52.071319],
          [-1.017586, 52.071225],
          [-1.017254, 52.071201],
          [-1.016911, 52.071192],
          [-1.01652, 52.071225],
          [-1.016165, 52.071281],
          [-1.015846, 52.07139],
          [-1.013762, 52.072408],
          [-1.013626, 52.072464],
          [-1.01346, 52.072516],
          [-1.013289, 52.072526],
          [-1.013159, 52.072497],
          [-1.01304, 52.072431],
          [-1.012969, 52.072356],
          [-1.012614, 52.071592],
          [-1.012507, 52.071484],
          [-1.01236, 52.071418],
          [-1.012188, 52.071413],
          [-1.011998, 52.071465],
          [-1.01188, 52.071559],
          [-1.011803, 52.071658],
          [-1.011655, 52.071908],
          [-1.011537, 52.07212],
          [-1.011448, 52.072328],
          [-1.011401, 52.07253],
          [-1.011371, 52.072743],
          [-1.011395, 52.072964],
          [-1.011466, 52.073063],
          [-1.011649, 52.07319],
          [-1.018403, 52.07698],
          [-1.018586, 52.077051],
          [-1.018841, 52.077131],
          [-1.019154, 52.077159],
          [-1.01948, 52.077136],
          [-1.019811, 52.077037],
          [-1.01993, 52.076947],
          [-1.020013, 52.076815],
          [-1.020149, 52.076127],
          [-1.020226, 52.075986],
          [-1.020391, 52.075872],
          [-1.02064, 52.075797],
          [-1.020912, 52.075773],
          [-1.021214, 52.075821],
          [-1.021427, 52.07591],
          [-1.021557, 52.076014],
          [-1.021658, 52.076136],
          [-1.021676, 52.076268],
          [-1.021634, 52.07641],
          [-1.021469, 52.076641],
          [-1.020599, 52.077701],
          [-1.02032, 52.077904],
          [-1.020048, 52.078074],
          [-1.019657, 52.078281],
          [-1.019338, 52.078418],
          [-1.018935, 52.078522],
          [-1.018586, 52.078592],
          [-1.017846, 52.078649],
          [-1.015349, 52.07879]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'de-1932',
        Location: 'Hockenheim',
        Name: 'Hockenheimring',
        opened: 1932,
        firstgp: 1970,
        length: 4574,
        altitude: 148
      },
      bbox: [8.564229, 49.325608, 8.584294, 49.333824],
      geometry: {
        type: 'LineString',
        coordinates: [
          [8.565865, 49.327768],
          [8.565045, 49.328856],
          [8.564246, 49.329827],
          [8.564229, 49.329902],
          [8.564264, 49.329978],
          [8.564625, 49.330515],
          [8.564797, 49.330756],
          [8.56498, 49.330977],
          [8.565176, 49.33117],
          [8.565371, 49.331335],
          [8.565732, 49.331609],
          [8.566513, 49.332132],
          [8.568922, 49.333777],
          [8.569023, 49.33381],
          [8.569159, 49.333824],
          [8.569272, 49.333791],
          [8.56939, 49.33372],
          [8.56952, 49.333584],
          [8.569615, 49.333414],
          [8.569633, 49.333268],
          [8.569627, 49.333065],
          [8.56965, 49.332957],
          [8.569686, 49.332863],
          [8.569787, 49.332731],
          [8.569899, 49.332636],
          [8.570094, 49.332542],
          [8.570662, 49.332316],
          [8.571266, 49.332094],
          [8.5719, 49.331887],
          [8.572497, 49.331703],
          [8.572947, 49.33158],
          [8.573509, 49.331453],
          [8.574066, 49.331354],
          [8.574551, 49.331279],
          [8.575202, 49.331203],
          [8.575652, 49.331166],
          [8.576173, 49.331137],
          [8.576611, 49.331133],
          [8.577179, 49.331151],
          [8.577736, 49.331189],
          [8.578298, 49.33126],
          [8.578931, 49.331368],
          [8.580109, 49.331628],
          [8.58398, 49.332584],
          [8.584104, 49.332599],
          [8.584211, 49.33258],
          [8.584276, 49.332523],
          [8.584294, 49.332462],
          [8.584264, 49.332405],
          [8.584193, 49.332358],
          [8.582707, 49.331722],
          [8.579606, 49.330388],
          [8.579387, 49.330331],
          [8.579144, 49.330317],
          [8.575729, 49.330595],
          [8.575581, 49.330595],
          [8.57548, 49.330539],
          [8.575421, 49.330416],
          [8.575404, 49.330218],
          [8.575433, 49.329968],
          [8.575528, 49.329766],
          [8.575688, 49.329577],
          [8.575889, 49.329403],
          [8.575966, 49.329304],
          [8.575995, 49.3292],
          [8.575995, 49.329106],
          [8.575954, 49.329007],
          [8.575853, 49.32887],
          [8.575729, 49.328757],
          [8.575575, 49.328658],
          [8.575273, 49.328502],
          [8.573628, 49.327786],
          [8.571675, 49.326956],
          [8.571497, 49.326895],
          [8.571302, 49.326853],
          [8.571124, 49.326843],
          [8.570923, 49.326857],
          [8.570751, 49.326881],
          [8.57058, 49.326928],
          [8.570414, 49.326999],
          [8.570236, 49.327102],
          [8.570017, 49.327277],
          [8.568265, 49.328625],
          [8.568135, 49.328696],
          [8.567987, 49.328743],
          [8.567827, 49.328752],
          [8.567668, 49.328743],
          [8.567531, 49.3287],
          [8.567425, 49.32863],
          [8.567336, 49.328545],
          [8.567289, 49.328446],
          [8.567283, 49.328342],
          [8.567312, 49.328224],
          [8.567597, 49.327649],
          [8.567668, 49.327555],
          [8.567774, 49.327456],
          [8.567928, 49.327371],
          [8.568094, 49.327319],
          [8.568449, 49.32723],
          [8.56862, 49.327168],
          [8.568751, 49.327088],
          [8.568893, 49.326975],
          [8.569337, 49.326565],
          [8.569414, 49.326452],
          [8.569443, 49.326372],
          [8.569431, 49.326287],
          [8.569396, 49.326197],
          [8.569289, 49.326108],
          [8.569112, 49.326014],
          [8.568455, 49.325707],
          [8.56823, 49.325627],
          [8.568076, 49.325608],
          [8.567904, 49.325608],
          [8.567703, 49.325636],
          [8.56752, 49.325712],
          [8.567354, 49.32582],
          [8.567206, 49.325957],
          [8.567076, 49.326108],
          [8.565865, 49.327768]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'hu-1986',
        Location: 'Budapest',
        Name: 'Hungaroring',
        opened: 1986,
        firstgp: 1986,
        length: 4381,
        altitude: 239
      },
      bbox: [19.242326, 47.577571, 19.256609, 47.588474],
      geometry: {
        type: 'LineString',
        coordinates: [
          [19.245888, 47.58026],
          [19.243226, 47.581696],
          [19.242439, 47.582111],
          [19.242368, 47.582191],
          [19.242326, 47.582271],
          [19.242338, 47.582361],
          [19.242391, 47.582431],
          [19.242468, 47.582478],
          [19.242569, 47.582511],
          [19.242717, 47.582526],
          [19.242936, 47.582526],
          [19.243546, 47.582516],
          [19.243954, 47.582469],
          [19.244327, 47.582394],
          [19.244718, 47.58229],
          [19.245014, 47.582177],
          [19.245238, 47.582073],
          [19.247411, 47.580913],
          [19.24757, 47.580857],
          [19.247724, 47.580833],
          [19.247878, 47.580833],
          [19.248003, 47.580862],
          [19.248139, 47.580895],
          [19.248245, 47.580951],
          [19.248334, 47.581017],
          [19.248393, 47.581078],
          [19.248446, 47.581163],
          [19.248464, 47.581281],
          [19.248458, 47.581347],
          [19.248411, 47.581437],
          [19.24837, 47.581526],
          [19.247748, 47.582238],
          [19.247683, 47.58237],
          [19.247671, 47.582474],
          [19.247707, 47.582563],
          [19.247754, 47.582676],
          [19.247813, 47.58278],
          [19.2485, 47.583704],
          [19.249719, 47.585368],
          [19.249938, 47.585632],
          [19.250193, 47.585863],
          [19.250512, 47.586113],
          [19.250577, 47.586183],
          [19.250625, 47.586254],
          [19.250636, 47.586334],
          [19.250601, 47.586424],
          [19.250045, 47.587838],
          [19.250033, 47.587946],
          [19.25005, 47.58805],
          [19.250092, 47.588154],
          [19.250157, 47.588253],
          [19.250275, 47.588333],
          [19.250417, 47.588404],
          [19.250565, 47.588455],
          [19.250713, 47.588474],
          [19.250897, 47.58847],
          [19.251074, 47.588441],
          [19.251288, 47.58838],
          [19.25153, 47.588276],
          [19.251702, 47.588196],
          [19.251903, 47.588097],
          [19.252116, 47.587984],
          [19.252383, 47.587796],
          [19.253519, 47.586966],
          [19.253572, 47.586886],
          [19.25359, 47.586824],
          [19.253584, 47.586758],
          [19.253525, 47.586702],
          [19.25343, 47.586641],
          [19.253353, 47.586589],
          [19.253324, 47.586542],
          [19.25333, 47.586457],
          [19.253359, 47.586363],
          [19.253773, 47.585311],
          [19.253862, 47.58517],
          [19.253927, 47.585113],
          [19.253992, 47.585062],
          [19.254081, 47.585014],
          [19.254188, 47.584991],
          [19.254389, 47.584963],
          [19.255247, 47.584878],
          [19.255425, 47.584831],
          [19.255537, 47.584779],
          [19.255632, 47.584727],
          [19.255715, 47.584637],
          [19.255744, 47.584557],
          [19.25578, 47.584463],
          [19.25578, 47.584359],
          [19.25575, 47.584246],
          [19.255537, 47.583233],
          [19.255531, 47.583053],
          [19.255549, 47.58294],
          [19.255596, 47.582823],
          [19.255662, 47.582709],
          [19.256502, 47.581804],
          [19.256585, 47.581668],
          [19.256603, 47.581573],
          [19.256609, 47.581484],
          [19.256591, 47.58139],
          [19.256561, 47.581295],
          [19.256502, 47.58121],
          [19.256407, 47.581126],
          [19.254963, 47.580032],
          [19.253679, 47.579028],
          [19.253241, 47.578698],
          [19.253134, 47.578656],
          [19.253034, 47.578646],
          [19.252939, 47.578656],
          [19.252856, 47.578689],
          [19.252773, 47.57874],
          [19.251897, 47.57941],
          [19.251755, 47.579504],
          [19.251086, 47.579872],
          [19.250968, 47.579914],
          [19.25085, 47.579947],
          [19.250707, 47.579961],
          [19.250583, 47.579952],
          [19.250417, 47.5799],
          [19.250317, 47.579825],
          [19.250246, 47.579744],
          [19.250204, 47.579674],
          [19.250193, 47.579579],
          [19.25021, 47.579485],
          [19.250269, 47.579396],
          [19.250346, 47.579325],
          [19.251666, 47.578608],
          [19.251909, 47.578458],
          [19.25198, 47.578377],
          [19.252033, 47.578264],
          [19.252057, 47.578132],
          [19.252039, 47.57801],
          [19.25198, 47.577906],
          [19.251909, 47.577807],
          [19.251797, 47.577722],
          [19.251613, 47.577642],
          [19.251424, 47.57759],
          [19.251217, 47.577571],
          [19.250998, 47.57759],
          [19.250802, 47.577642],
          [19.250619, 47.577727],
          [19.245888, 47.58026]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'be-1925',
        Location: 'Spa Francorchamps',
        Name: 'Circuit de Spa-Francorchamps',
        opened: 1925,
        firstgp: 1950,
        length: 7004,
        altitude: 413
      },
      bbox: [5.959602, 50.427678, 5.97756, 50.446217],
      geometry: {
        type: 'LineString',
        coordinates: [
          [5.96502, 50.444251],
          [5.963419, 50.446033],
          [5.963402, 50.446113],
          [5.963473, 50.446184],
          [5.963621, 50.446217],
          [5.963786, 50.446188],
          [5.964313, 50.446019],
          [5.965592, 50.445628],
          [5.966207, 50.445387],
          [5.966847, 50.445085],
          [5.967421, 50.444779],
          [5.967876, 50.444463],
          [5.970321, 50.442606],
          [5.970493, 50.442502],
          [5.970788, 50.442385],
          [5.971315, 50.442168],
          [5.971546, 50.442022],
          [5.971741, 50.441824],
          [5.971866, 50.441644],
          [5.971949, 50.441442],
          [5.97202, 50.441069],
          [5.972061, 50.440937],
          [5.972132, 50.440815],
          [5.972268, 50.440655],
          [5.973476, 50.439424],
          [5.974245, 50.438642],
          [5.974458, 50.43835],
          [5.974594, 50.438133],
          [5.974754, 50.437784],
          [5.975719, 50.435639],
          [5.977199, 50.432382],
          [5.977542, 50.431599],
          [5.97756, 50.431472],
          [5.977524, 50.431331],
          [5.977406, 50.431218],
          [5.977234, 50.431123],
          [5.977015, 50.431048],
          [5.976885, 50.430968],
          [5.976796, 50.430874],
          [5.976725, 50.430732],
          [5.976737, 50.430591],
          [5.977033, 50.429747],
          [5.977027, 50.429601],
          [5.97698, 50.429469],
          [5.97682, 50.429323],
          [5.97663, 50.429224],
          [5.973257, 50.427739],
          [5.973044, 50.427682],
          [5.972831, 50.427678],
          [5.972606, 50.42772],
          [5.972422, 50.427805],
          [5.972292, 50.427927],
          [5.972239, 50.42805],
          [5.972227, 50.428182],
          [5.972292, 50.428305],
          [5.97241, 50.428432],
          [5.972582, 50.428521],
          [5.974056, 50.429101],
          [5.974216, 50.429205],
          [5.974304, 50.429309],
          [5.97434, 50.429431],
          [5.974322, 50.429582],
          [5.973712, 50.430723],
          [5.973523, 50.431189],
          [5.973091, 50.432627],
          [5.972878, 50.433452],
          [5.972831, 50.433593],
          [5.972724, 50.433744],
          [5.972582, 50.433867],
          [5.972369, 50.433999],
          [5.972132, 50.434098],
          [5.971872, 50.434164],
          [5.971599, 50.434192],
          [5.970717, 50.43423],
          [5.97038, 50.434206],
          [5.970072, 50.43415],
          [5.969759, 50.434065],
          [5.969504, 50.433956],
          [5.969208, 50.433782],
          [5.969019, 50.433608],
          [5.968812, 50.433358],
          [5.967977, 50.432028],
          [5.967231, 50.430845],
          [5.967071, 50.430661],
          [5.966882, 50.430534],
          [5.966622, 50.43044],
          [5.966361, 50.430393],
          [5.966119, 50.430388],
          [5.965876, 50.430421],
          [5.965669, 50.430482],
          [5.965325, 50.430624],
          [5.9651, 50.430685],
          [5.964828, 50.430713],
          [5.964556, 50.430694],
          [5.964307, 50.430643],
          [5.964094, 50.430548],
          [5.963958, 50.43044],
          [5.963792, 50.430294],
          [5.962425, 50.428927],
          [5.962289, 50.428847],
          [5.962123, 50.42879],
          [5.961922, 50.428762],
          [5.961697, 50.428771],
          [5.961502, 50.428828],
          [5.960578, 50.429257],
          [5.960034, 50.429511],
          [5.959898, 50.429624],
          [5.959756, 50.429761],
          [5.959673, 50.429893],
          [5.959614, 50.430049],
          [5.959602, 50.430209],
          [5.959643, 50.430402],
          [5.959738, 50.430567],
          [5.959862, 50.430779],
          [5.960046, 50.4311],
          [5.960365, 50.431463],
          [5.960715, 50.431779],
          [5.961247, 50.43216],
          [5.962135, 50.432712],
          [5.962656, 50.432971],
          [5.9631, 50.433136],
          [5.965385, 50.433895],
          [5.965716, 50.434027],
          [5.96603, 50.434183],
          [5.96632, 50.434357],
          [5.966568, 50.434546],
          [5.966799, 50.434744],
          [5.967107, 50.435106],
          [5.967356, 50.435455],
          [5.967924, 50.436261],
          [5.968024, 50.436436],
          [5.968084, 50.436624],
          [5.968095, 50.43686],
          [5.968036, 50.437072],
          [5.967699, 50.437624],
          [5.967332, 50.438232],
          [5.966888, 50.438991],
          [5.966775, 50.439273],
          [5.966669, 50.439608],
          [5.966604, 50.439919],
          [5.966562, 50.440183],
          [5.966432, 50.441404],
          [5.966456, 50.441484],
          [5.966533, 50.441541],
          [5.966651, 50.44156],
          [5.966852, 50.441541],
          [5.96706, 50.441541],
          [5.967202, 50.44156],
          [5.967296, 50.441626],
          [5.96732, 50.441701],
          [5.967261, 50.4418],
          [5.966533, 50.442559],
          [5.96502, 50.444251]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'it-1922',
        Location: 'Monza',
        Name: 'Autodromo Nazionale Monza',
        opened: 1922,
        firstgp: 1950,
        length: 5793,
        altitude: 142
      },
      bbox: [9.280697, 45.611858, 9.296856, 45.631364],
      geometry: {
        type: 'LineString',
        coordinates: [
          [9.281223, 45.618975],
          [9.281692, 45.622832],
          [9.281905, 45.624449],
          [9.281928, 45.624515],
          [9.281994, 45.624553],
          [9.282076, 45.624562],
          [9.282177, 45.624553],
          [9.282272, 45.624548],
          [9.28236, 45.624553],
          [9.28242, 45.624586],
          [9.282467, 45.624633],
          [9.282479, 45.624675],
          [9.282479, 45.624722],
          [9.282147, 45.625604],
          [9.2821, 45.625844],
          [9.282082, 45.626061],
          [9.282106, 45.626297],
          [9.28223, 45.627447],
          [9.282278, 45.627635],
          [9.282337, 45.62781],
          [9.282426, 45.627998],
          [9.282544, 45.628201],
          [9.28268, 45.628399],
          [9.282881, 45.628621],
          [9.283088, 45.628804],
          [9.283367, 45.629012],
          [9.283669, 45.629196],
          [9.284006, 45.629365],
          [9.284367, 45.629511],
          [9.284775, 45.629653],
          [9.285184, 45.629752],
          [9.285634, 45.629841],
          [9.286143, 45.629903],
          [9.286664, 45.629936],
          [9.288694, 45.630058],
          [9.29118, 45.630162],
          [9.291328, 45.630171],
          [9.291405, 45.6302],
          [9.29147, 45.630247],
          [9.291552, 45.63045],
          [9.291588, 45.630506],
          [9.291647, 45.630544],
          [9.291748, 45.630567],
          [9.292085, 45.63061],
          [9.292452, 45.630666],
          [9.292973, 45.630784],
          [9.295299, 45.631331],
          [9.2955, 45.631364],
          [9.29569, 45.631364],
          [9.295873, 45.63134],
          [9.296003, 45.631303],
          [9.296128, 45.631251],
          [9.296246, 45.631194],
          [9.296394, 45.631081],
          [9.296477, 45.630992],
          [9.296536, 45.630883],
          [9.296566, 45.630761],
          [9.296666, 45.629988],
          [9.296856, 45.628668],
          [9.29685, 45.62855],
          [9.29682, 45.628474],
          [9.296773, 45.628408],
          [9.296696, 45.628361],
          [9.296554, 45.628295],
          [9.295033, 45.62772],
          [9.293796, 45.627235],
          [9.293026, 45.626938],
          [9.292653, 45.626787],
          [9.292233, 45.62658],
          [9.291931, 45.626419],
          [9.291671, 45.626259],
          [9.290321, 45.625448],
          [9.289363, 45.62484],
          [9.287338, 45.623596],
          [9.286119, 45.622846],
          [9.285953, 45.622728],
          [9.285888, 45.622653],
          [9.285876, 45.622578],
          [9.285876, 45.622488],
          [9.285918, 45.62229],
          [9.28593, 45.622182],
          [9.28593, 45.622026],
          [9.285912, 45.621941],
          [9.285864, 45.621833],
          [9.285793, 45.621706],
          [9.285675, 45.621578],
          [9.285515, 45.621446],
          [9.285332, 45.621338],
          [9.285184, 45.621258],
          [9.285107, 45.621196],
          [9.285048, 45.621112],
          [9.284994, 45.620956],
          [9.28487, 45.620244],
          [9.28474, 45.619485],
          [9.283734, 45.612679],
          [9.283692, 45.612434],
          [9.283651, 45.61232],
          [9.283568, 45.612203],
          [9.283455, 45.612108],
          [9.283325, 45.612023],
          [9.283142, 45.611939],
          [9.282941, 45.611887],
          [9.28271, 45.611858],
          [9.282514, 45.611868],
          [9.282331, 45.611896],
          [9.282118, 45.611953],
          [9.281911, 45.612019],
          [9.281757, 45.612094],
          [9.281573, 45.612193],
          [9.281366, 45.612349],
          [9.281224, 45.61249],
          [9.2811, 45.612641],
          [9.280993, 45.61282],
          [9.280893, 45.613018],
          [9.280816, 45.613221],
          [9.28078, 45.613395],
          [9.280739, 45.613659],
          [9.280733, 45.613923],
          [9.280727, 45.614173],
          [9.280709, 45.614668],
          [9.280697, 45.615102],
          [9.280709, 45.615573],
          [9.280786, 45.61619],
          [9.281076, 45.618142],
          [9.281223, 45.618975]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'sg-2008',
        Location: 'Singapore',
        Name: 'Marina Bay Street Circuit',
        opened: 2008,
        firstgp: 2008,
        length: 5063,
        altitude: 18
      },
      bbox: [103.851545, 1.286293, 103.864454, 1.294834],
      geometry: {
        type: 'LineString',
        coordinates: [
          [103.863969, 1.293246],
          [103.864224, 1.291318],
          [103.864454, 1.289673],
          [103.864443, 1.28947],
          [103.864395, 1.2893],
          [103.864087, 1.288777],
          [103.863981, 1.288673],
          [103.863797, 1.288631],
          [103.863129, 1.288664],
          [103.861732, 1.288725],
          [103.861483, 1.288772],
          [103.86127, 1.28889],
          [103.861199, 1.289018],
          [103.861187, 1.289296],
          [103.86114, 1.289423],
          [103.860992, 1.289503],
          [103.860832, 1.289527],
          [103.860175, 1.289574],
          [103.860009, 1.289555],
          [103.859938, 1.289479],
          [103.859814, 1.288928],
          [103.859743, 1.288796],
          [103.859583, 1.288735],
          [103.858098, 1.288829],
          [103.857873, 1.288895],
          [103.857772, 1.28897],
          [103.857707, 1.289098],
          [103.8576, 1.289508],
          [103.857565, 1.289588],
          [103.85747, 1.289668],
          [103.857222, 1.289715],
          [103.856926, 1.289781],
          [103.856665, 1.289913],
          [103.855665, 1.290729],
          [103.85528, 1.291092],
          [103.855103, 1.291219],
          [103.854984, 1.291228],
          [103.854901, 1.291153],
          [103.854848, 1.291049],
          [103.85473, 1.290672],
          [103.854629, 1.290271],
          [103.854392, 1.289008],
          [103.85396, 1.286576],
          [103.853919, 1.286397],
          [103.853877, 1.286312],
          [103.853818, 1.286293],
          [103.853765, 1.286307],
          [103.853658, 1.286439],
          [103.853481, 1.286712],
          [103.85338, 1.286859],
          [103.853256, 1.287],
          [103.852984, 1.287231],
          [103.852652, 1.287523],
          [103.852552, 1.287632],
          [103.852469, 1.287745],
          [103.852433, 1.287844],
          [103.852368, 1.288268],
          [103.852362, 1.288414],
          [103.852344, 1.288457],
          [103.852315, 1.288475],
          [103.852262, 1.288485],
          [103.852202, 1.288499],
          [103.852143, 1.288518],
          [103.85177, 1.288763],
          [103.851681, 1.288838],
          [103.85161, 1.288933],
          [103.851551, 1.289051],
          [103.851545, 1.289145],
          [103.851545, 1.289272],
          [103.851563, 1.289366],
          [103.851628, 1.289498],
          [103.852445, 1.290917],
          [103.853126, 1.292199],
          [103.853244, 1.292345],
          [103.853386, 1.292444],
          [103.85354, 1.292501],
          [103.85367, 1.292515],
          [103.853783, 1.292468],
          [103.853889, 1.292397],
          [103.853984, 1.292308],
          [103.854848, 1.291483],
          [103.854966, 1.291436],
          [103.855061, 1.291488],
          [103.855428, 1.292195],
          [103.855866, 1.292986],
          [103.855984, 1.293057],
          [103.856127, 1.293024],
          [103.858299, 1.291676],
          [103.858713, 1.291483],
          [103.859104, 1.291389],
          [103.862412, 1.291209],
          [103.862625, 1.291252],
          [103.862791, 1.291346],
          [103.862921, 1.291497],
          [103.862975, 1.291671],
          [103.862963, 1.291888],
          [103.862844, 1.292572],
          [103.862477, 1.293741],
          [103.86246, 1.294009],
          [103.862489, 1.294533],
          [103.862549, 1.29474],
          [103.862667, 1.294825],
          [103.862809, 1.294834],
          [103.862904, 1.294749],
          [103.863028, 1.29457],
          [103.863188, 1.294429],
          [103.863383, 1.29433],
          [103.863561, 1.294306],
          [103.863715, 1.294325],
          [103.863851, 1.294245],
          [103.863892, 1.294104],
          [103.863969, 1.293246]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'ru-2014',
        Location: 'Sochi',
        Name: 'Sochi Autodrom',
        opened: 2014,
        firstgp: 2014,
        length: 5848,
        altitude: 23
      },
      bbox: [39.947309, 43.402181, 39.97015, 43.41273],
      geometry: {
        type: 'LineString',
        coordinates: [
          [39.968066, 43.409699],
          [39.966723, 43.408191],
          [39.966421, 43.407965],
          [39.966007, 43.407734],
          [39.965551, 43.407555],
          [39.9649, 43.407408],
          [39.963177, 43.407074],
          [39.96062, 43.406574],
          [39.957886, 43.406046],
          [39.957708, 43.40606],
          [39.957643, 43.406098],
          [39.957602, 43.406221],
          [39.957531, 43.406395],
          [39.957418, 43.406522],
          [39.956181, 43.407399],
          [39.955737, 43.407635],
          [39.955187, 43.407795],
          [39.954524, 43.407837],
          [39.953879, 43.407743],
          [39.953334, 43.407536],
          [39.952908, 43.407248],
          [39.952648, 43.406965],
          [39.95244, 43.406621],
          [39.952363, 43.406249],
          [39.952399, 43.405834],
          [39.952547, 43.405481],
          [39.953316, 43.404321],
          [39.953334, 43.404189],
          [39.953263, 43.404085],
          [39.953086, 43.403991],
          [39.948996, 43.402223],
          [39.948871, 43.402186],
          [39.948676, 43.402181],
          [39.948534, 43.402242],
          [39.948439, 43.402332],
          [39.947427, 43.403977],
          [39.947332, 43.404255],
          [39.947309, 43.404481],
          [39.947338, 43.404731],
          [39.947599, 43.405688],
          [39.947646, 43.405768],
          [39.947747, 43.405806],
          [39.947877, 43.405834],
          [39.951209, 43.406197],
          [39.951292, 43.406221],
          [39.951369, 43.406268],
          [39.951428, 43.406329],
          [39.951635, 43.406928],
          [39.951653, 43.407017],
          [39.951665, 43.40713],
          [39.951647, 43.407229],
          [39.950612, 43.409346],
          [39.950612, 43.409431],
          [39.950653, 43.409506],
          [39.95073, 43.409581],
          [39.950842, 43.409638],
          [39.951884, 43.409944],
          [39.952363, 43.410025],
          [39.952813, 43.410086],
          [39.953429, 43.410119],
          [39.953973, 43.410114],
          [39.954595, 43.410067],
          [39.955181, 43.409987],
          [39.956211, 43.409864],
          [39.956761, 43.409761],
          [39.957324, 43.409614],
          [39.957933, 43.409435],
          [39.960028, 43.408742],
          [39.960603, 43.408596],
          [39.961123, 43.408516],
          [39.961703, 43.408478],
          [39.962301, 43.408497],
          [39.962858, 43.408573],
          [39.96371, 43.408752],
          [39.96387, 43.408724],
          [39.963935, 43.408648],
          [39.964201, 43.407988],
          [39.964326, 43.407894],
          [39.964539, 43.407837],
          [39.964769, 43.407847],
          [39.965101, 43.407903],
          [39.965474, 43.40804],
          [39.965805, 43.408257],
          [39.966078, 43.408535],
          [39.966681, 43.409167],
          [39.966711, 43.409242],
          [39.966699, 43.409303],
          [39.966587, 43.409369],
          [39.966036, 43.409666],
          [39.965935, 43.40977],
          [39.9659, 43.409916],
          [39.965965, 43.410048],
          [39.966841, 43.411033],
          [39.967622, 43.411962],
          [39.96825, 43.412664],
          [39.968392, 43.41273],
          [39.968569, 43.412693],
          [39.969972, 43.41224],
          [39.970102, 43.412183],
          [39.97015, 43.412099],
          [39.970114, 43.412004],
          [39.968066, 43.409699]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'jp-1962',
        Location: 'Suzuka',
        Name: 'Suzuka International Racing Course',
        opened: 1962,
        firstgp: 1987,
        length: 5807,
        altitude: 60
      },
      bbox: [136.521946, 34.838956, 136.543438, 34.848374],
      geometry: {
        type: 'LineString',
        coordinates: [
          [136.540283, 34.843344],
          [136.541609, 34.842034],
          [136.54316, 34.840474],
          [136.543302, 34.840309],
          [136.543396, 34.840163],
          [136.543432, 34.840026],
          [136.543438, 34.839899],
          [136.543426, 34.839771],
          [136.543248, 34.839258],
          [136.543166, 34.839149],
          [136.543059, 34.83906],
          [136.542899, 34.838994],
          [136.54271, 34.838956],
          [136.542538, 34.838961],
          [136.542349, 34.839013],
          [136.542195, 34.839097],
          [136.542071, 34.839211],
          [136.5411, 34.840455],
          [136.540946, 34.840577],
          [136.540757, 34.840662],
          [136.540567, 34.8407],
          [136.540153, 34.8407],
          [136.539922, 34.840738],
          [136.539733, 34.840832],
          [136.539585, 34.840945],
          [136.539466, 34.841101],
          [136.539253, 34.841765],
          [136.539164, 34.841935],
          [136.539022, 34.842081],
          [136.538857, 34.84218],
          [136.538649, 34.84226],
          [136.538436, 34.842293],
          [136.537921, 34.842307],
          [136.537714, 34.842331],
          [136.537537, 34.842397],
          [136.537359, 34.842501],
          [136.537205, 34.842642],
          [136.537093, 34.842812],
          [136.537045, 34.842972],
          [136.537039, 34.843109],
          [136.537075, 34.843231],
          [136.537341, 34.843839],
          [136.537371, 34.843934],
          [136.537389, 34.844089],
          [136.537353, 34.844264],
          [136.537282, 34.844419],
          [136.537176, 34.844551],
          [136.537034, 34.84466],
          [136.53685, 34.844749],
          [136.536501, 34.844895],
          [136.536175, 34.844985],
          [136.53585, 34.845046],
          [136.535506, 34.84506],
          [136.535211, 34.845051],
          [136.535021, 34.845018],
          [136.534802, 34.844961],
          [136.534548, 34.844872],
          [136.534281, 34.844749],
          [136.533997, 34.844579],
          [136.53376, 34.844377],
          [136.532725, 34.84333],
          [136.53263, 34.843264],
          [136.532512, 34.843241],
          [136.531038, 34.843132],
          [136.530943, 34.843142],
          [136.530842, 34.843198],
          [136.530801, 34.843293],
          [136.530783, 34.843373],
          [136.530227, 34.845621],
          [136.530203, 34.845748],
          [136.530191, 34.84588],
          [136.530203, 34.846017],
          [136.530239, 34.846159],
          [136.530304, 34.846305],
          [136.530381, 34.846446],
          [136.530635, 34.846922],
          [136.530665, 34.846983],
          [136.530665, 34.847045],
          [136.530647, 34.847111],
          [136.530546, 34.847196],
          [136.530416, 34.847214],
          [136.530304, 34.847186],
          [136.530209, 34.847111],
          [136.529522, 34.846196],
          [136.529369, 34.846022],
          [136.529209, 34.845866],
          [136.529055, 34.845739],
          [136.52883, 34.845593],
          [136.528593, 34.845489],
          [136.528345, 34.845428],
          [136.527913, 34.845376],
          [136.527504, 34.845362],
          [136.527196, 34.845381],
          [136.526829, 34.845447],
          [136.526522, 34.845513],
          [136.525977, 34.845678],
          [136.525693, 34.845786],
          [136.525444, 34.845909],
          [136.525214, 34.84605],
          [136.524971, 34.846229],
          [136.524781, 34.846408],
          [136.524616, 34.846611],
          [136.524456, 34.846851],
          [136.52384, 34.84803],
          [136.52374, 34.848171],
          [136.523604, 34.848275],
          [136.523426, 34.848341],
          [136.523213, 34.848374],
          [136.522958, 34.848369],
          [136.522722, 34.848341],
          [136.522491, 34.848299],
          [136.522266, 34.848223],
          [136.522124, 34.848129],
          [136.522023, 34.848006],
          [136.521958, 34.847874],
          [136.521946, 34.847738],
          [136.521976, 34.847577],
          [136.522053, 34.847422],
          [136.522189, 34.847257],
          [136.522331, 34.847125],
          [136.522609, 34.846922],
          [136.523047, 34.846639],
          [136.523385, 34.846437],
          [136.523704, 34.846258],
          [136.524237, 34.845994],
          [136.524817, 34.84573],
          [136.525314, 34.845536],
          [136.525817, 34.845367],
          [136.530138, 34.844118],
          [136.530842, 34.84391],
          [136.531044, 34.843868],
          [136.531245, 34.843863],
          [136.531458, 34.843896],
          [136.531665, 34.843943],
          [136.532038, 34.844061],
          [136.532381, 34.844202],
          [136.532695, 34.844372],
          [136.532985, 34.844561],
          [136.533524, 34.844966],
          [136.534287, 34.84555],
          [136.53453, 34.845725],
          [136.534684, 34.845814],
          [136.534802, 34.845871],
          [136.534915, 34.845904],
          [136.535009, 34.845876],
          [136.535181, 34.845758],
          [136.535305, 34.845673],
          [136.535406, 34.845649],
          [136.535501, 34.845664],
          [136.535613, 34.845725],
          [136.535797, 34.845862],
          [136.536004, 34.845984],
          [136.536235, 34.846064],
          [136.536442, 34.846093],
          [136.536744, 34.846088],
          [136.537028, 34.84605],
          [136.5373, 34.84597],
          [136.537572, 34.845843],
          [136.537868, 34.845678],
          [136.538134, 34.845475],
          [136.538407, 34.845225],
          [136.540283, 34.843344]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'us-2012',
        Location: 'Austin',
        Name: 'Circuit of the Americas',
        opened: 2012,
        firstgp: 2012,
        length: 5513,
        altitude: 130
      },
      bbox: [-97.643463, 30.130031, -97.624458, 30.139453],
      geometry: {
        type: 'LineString',
        coordinates: [
          [-97.639651, 30.13176],
          [-97.637935, 30.130577],
          [-97.637461, 30.13029],
          [-97.637094, 30.130101],
          [-97.636958, 30.130045],
          [-97.636905, 30.130031],
          [-97.636846, 30.13004],
          [-97.636793, 30.130068],
          [-97.636757, 30.130115],
          [-97.636739, 30.130158],
          [-97.636745, 30.13021],
          [-97.637118, 30.131138],
          [-97.637284, 30.131567],
          [-97.637313, 30.131699],
          [-97.637319, 30.131812],
          [-97.637313, 30.131944],
          [-97.637284, 30.132067],
          [-97.637231, 30.132222],
          [-97.637148, 30.132354],
          [-97.637059, 30.132472],
          [-97.636935, 30.132595],
          [-97.636799, 30.13268],
          [-97.636615, 30.132779],
          [-97.635615, 30.133316],
          [-97.635206, 30.133538],
          [-97.635118, 30.133613],
          [-97.635041, 30.133703],
          [-97.634976, 30.133778],
          [-97.634922, 30.133882],
          [-97.634881, 30.133971],
          [-97.634774, 30.13423],
          [-97.634703, 30.134315],
          [-97.634614, 30.134414],
          [-97.634496, 30.13448],
          [-97.634401, 30.134523],
          [-97.634165, 30.134603],
          [-97.633981, 30.134683],
          [-97.633875, 30.134754],
          [-97.633809, 30.134824],
          [-97.63375, 30.134919],
          [-97.633727, 30.135032],
          [-97.633691, 30.135225],
          [-97.633673, 30.135348],
          [-97.633638, 30.135484],
          [-97.63359, 30.135583],
          [-97.633531, 30.135678],
          [-97.633454, 30.135772],
          [-97.633371, 30.135857],
          [-97.633247, 30.135951],
          [-97.633105, 30.136041],
          [-97.632951, 30.136116],
          [-97.632786, 30.136177],
          [-97.632643, 30.136206],
          [-97.632525, 30.13621],
          [-97.63243, 30.136206],
          [-97.632276, 30.136168],
          [-97.631294, 30.135777],
          [-97.631199, 30.135744],
          [-97.631099, 30.135744],
          [-97.631022, 30.135772],
          [-97.630826, 30.135876],
          [-97.630596, 30.136036],
          [-97.63043, 30.136182],
          [-97.630264, 30.136375],
          [-97.63014, 30.136502],
          [-97.630027, 30.136578],
          [-97.629903, 30.136625],
          [-97.629808, 30.136644],
          [-97.629672, 30.136644],
          [-97.629518, 30.136606],
          [-97.6294, 30.13655],
          [-97.629305, 30.136469],
          [-97.629252, 30.136413],
          [-97.629199, 30.136342],
          [-97.629151, 30.136262],
          [-97.62908, 30.136196],
          [-97.628997, 30.136168],
          [-97.628915, 30.136168],
          [-97.627145, 30.136507],
          [-97.627032, 30.13654],
          [-97.626961, 30.136573],
          [-97.626908, 30.136616],
          [-97.625872, 30.137704],
          [-97.624961, 30.138657],
          [-97.624612, 30.139043],
          [-97.624469, 30.139269],
          [-97.624458, 30.139326],
          [-97.624475, 30.139378],
          [-97.624517, 30.139406],
          [-97.62457, 30.139439],
          [-97.624629, 30.139453],
          [-97.624694, 30.139449],
          [-97.624783, 30.13943],
          [-97.626677, 30.138906],
          [-97.627997, 30.138586],
          [-97.629453, 30.13828],
          [-97.631193, 30.137978],
          [-97.632282, 30.137822],
          [-97.633289, 30.137695],
          [-97.636254, 30.137412],
          [-97.636585, 30.13736],
          [-97.636627, 30.137337],
          [-97.636645, 30.13729],
          [-97.636639, 30.137252],
          [-97.636597, 30.1372],
          [-97.636402, 30.137012],
          [-97.635727, 30.13621],
          [-97.635431, 30.135795],
          [-97.635413, 30.135734],
          [-97.635431, 30.135645],
          [-97.635473, 30.135583],
          [-97.63555, 30.135536],
          [-97.635615, 30.135522],
          [-97.635739, 30.135508],
          [-97.636289, 30.135546],
          [-97.636343, 30.135569],
          [-97.63639, 30.135607],
          [-97.636437, 30.135654],
          [-97.636479, 30.13572],
          [-97.636591, 30.135984],
          [-97.636639, 30.136088],
          [-97.636716, 30.136182],
          [-97.637077, 30.136502],
          [-97.63713, 30.13654],
          [-97.637195, 30.136564],
          [-97.63726, 30.136573],
          [-97.637615, 30.136601],
          [-97.637686, 30.136597],
          [-97.637728, 30.136573],
          [-97.637769, 30.136531],
          [-97.637787, 30.136474],
          [-97.637763, 30.136408],
          [-97.637077, 30.135385],
          [-97.636799, 30.134933],
          [-97.636775, 30.13481],
          [-97.636781, 30.134688],
          [-97.636804, 30.134589],
          [-97.636834, 30.13449],
          [-97.636911, 30.134306],
          [-97.637018, 30.134103],
          [-97.637089, 30.134023],
          [-97.637207, 30.133948],
          [-97.637343, 30.133891],
          [-97.637905, 30.13367],
          [-97.638018, 30.133646],
          [-97.63813, 30.133641],
          [-97.638337, 30.133655],
          [-97.638533, 30.133679],
          [-97.638722, 30.133731],
          [-97.638929, 30.133802],
          [-97.639113, 30.133896],
          [-97.639237, 30.133976],
          [-97.63932, 30.134098],
          [-97.639965, 30.134881],
          [-97.640468, 30.135428],
          [-97.640533, 30.135484],
          [-97.64061, 30.135513],
          [-97.640711, 30.135531],
          [-97.6408, 30.135527],
          [-97.640924, 30.135498],
          [-97.641072, 30.135456],
          [-97.641196, 30.135414],
          [-97.643274, 30.134626],
          [-97.643392, 30.134556],
          [-97.643439, 30.13449],
          [-97.643463, 30.134419],
          [-97.643439, 30.134367],
          [-97.643392, 30.13432],
          [-97.643333, 30.134273],
          [-97.642244, 30.133514],
          [-97.639651, 30.13176]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'mx-1962',
        Location: 'Mexico City',
        Name: 'Autódromo Hermanos Rodríguez',
        opened: 1962,
        firstgp: 1963,
        length: 4304,
        altitude: 2232
      },
      bbox: [-99.09685, 19.397044, -99.083095, 19.40641],
      geometry: {
        type: 'LineString',
        coordinates: [
          [-99.094338, 19.406226],
          [-99.090925, 19.405779],
          [-99.089818, 19.405642],
          [-99.088652, 19.405543],
          [-99.08809, 19.405477],
          [-99.08664, 19.405284],
          [-99.084113, 19.40493],
          [-99.083592, 19.404831],
          [-99.083503, 19.404798],
          [-99.083456, 19.40476],
          [-99.083432, 19.404699],
          [-99.083426, 19.404643],
          [-99.083521, 19.404053],
          [-99.083509, 19.404001],
          [-99.083479, 19.403954],
          [-99.083213, 19.403818],
          [-99.083136, 19.40378],
          [-99.083095, 19.403719],
          [-99.083095, 19.403662],
          [-99.083148, 19.403294],
          [-99.083231, 19.402964],
          [-99.083361, 19.402644],
          [-99.083509, 19.402356],
          [-99.084669, 19.400499],
          [-99.08606, 19.398439],
          [-99.086149, 19.398298],
          [-99.086161, 19.398213],
          [-99.086143, 19.398142],
          [-99.086101, 19.39809],
          [-99.085687, 19.39785],
          [-99.085646, 19.397812],
          [-99.08564, 19.397751],
          [-99.085669, 19.397699],
          [-99.08574, 19.397638],
          [-99.086516, 19.397086],
          [-99.086593, 19.397053],
          [-99.086658, 19.397044],
          [-99.086717, 19.397063],
          [-99.086859, 19.397148],
          [-99.086883, 19.397204],
          [-99.086883, 19.397317],
          [-99.086528, 19.399929],
          [-99.086533, 19.400009],
          [-99.086569, 19.400084],
          [-99.086622, 19.400146],
          [-99.086705, 19.400202],
          [-99.087119, 19.400443],
          [-99.087267, 19.40057],
          [-99.087356, 19.400655],
          [-99.087445, 19.400815],
          [-99.08754, 19.401051],
          [-99.087634, 19.401192],
          [-99.087741, 19.401291],
          [-99.087859, 19.401362],
          [-99.088019, 19.401428],
          [-99.089298, 19.401612],
          [-99.08944, 19.401654],
          [-99.089528, 19.401725],
          [-99.08957, 19.401772],
          [-99.089605, 19.401838],
          [-99.089771, 19.402323],
          [-99.089824, 19.402418],
          [-99.089907, 19.402507],
          [-99.090114, 19.402625],
          [-99.091061, 19.403106],
          [-99.091334, 19.403214],
          [-99.09173, 19.403304],
          [-99.094903, 19.403738],
          [-99.094968, 19.403761],
          [-99.095003, 19.403799],
          [-99.095033, 19.40386],
          [-99.095039, 19.40394],
          [-99.095092, 19.404709],
          [-99.095157, 19.405241],
          [-99.095181, 19.405302],
          [-99.095228, 19.405345],
          [-99.095293, 19.405373],
          [-99.095376, 19.405364],
          [-99.095465, 19.405288],
          [-99.095578, 19.405128],
          [-99.095643, 19.405081],
          [-99.09572, 19.405053],
          [-99.095808, 19.405057],
          [-99.095909, 19.4051],
          [-99.096027, 19.405152],
          [-99.09614, 19.405185],
          [-99.096678, 19.405241],
          [-99.096767, 19.405269],
          [-99.096809, 19.405302],
          [-99.096844, 19.405364],
          [-99.09685, 19.405425],
          [-99.096815, 19.405571],
          [-99.096738, 19.405764],
          [-99.096637, 19.405925],
          [-99.096489, 19.406118],
          [-99.096317, 19.40625],
          [-99.096098, 19.406354],
          [-99.095897, 19.406405],
          [-99.095702, 19.40641],
          [-99.095418, 19.406377],
          [-99.094338, 19.406226]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'br-1940',
        Location: 'Sao Paulo',
        Name: 'Autódromo José Carlos Pace',
        opened: 1940,
        firstgp: 1972,
        length: 4309,
        altitude: 765
      },
      bbox: [-46.700609, -23.70644, -46.694051, -23.696984],
      geometry: {
        type: 'LineString',
        coordinates: [
          [-46.69997, -23.703753],
          [-46.699384, -23.705804],
          [-46.699325, -23.705988],
          [-46.699242, -23.706153],
          [-46.699118, -23.706317],
          [-46.699005, -23.706402],
          [-46.698899, -23.70644],
          [-46.698798, -23.706431],
          [-46.698697, -23.706402],
          [-46.698626, -23.706355],
          [-46.698271, -23.706025],
          [-46.698188, -23.705997],
          [-46.698123, -23.705988],
          [-46.698035, -23.706006],
          [-46.697934, -23.706063],
          [-46.697632, -23.706237],
          [-46.697443, -23.706303],
          [-46.697265, -23.706332],
          [-46.697082, -23.706336],
          [-46.696892, -23.706327],
          [-46.696709, -23.706299],
          [-46.696543, -23.706256],
          [-46.696371, -23.70619],
          [-46.696164, -23.706063],
          [-46.696028, -23.70595],
          [-46.69591, -23.705813],
          [-46.695797, -23.705658],
          [-46.695714, -23.705526],
          [-46.695661, -23.705389],
          [-46.69485, -23.702594],
          [-46.694116, -23.700142],
          [-46.694069, -23.699982],
          [-46.694051, -23.699864],
          [-46.694063, -23.69977],
          [-46.694116, -23.699685],
          [-46.694181, -23.69961],
          [-46.694246, -23.699572],
          [-46.694323, -23.699534],
          [-46.694531, -23.699473],
          [-46.695128, -23.699379],
          [-46.695306, -23.699369],
          [-46.695495, -23.69936],
          [-46.695626, -23.699379],
          [-46.695768, -23.699412],
          [-46.695916, -23.699464],
          [-46.696046, -23.699534],
          [-46.696194, -23.699633],
          [-46.69633, -23.699761],
          [-46.69649, -23.699945],
          [-46.698165, -23.702066],
          [-46.698319, -23.702221],
          [-46.698461, -23.702339],
          [-46.698591, -23.7024],
          [-46.698733, -23.702429],
          [-46.698911, -23.702433],
          [-46.699088, -23.7024],
          [-46.699218, -23.702377],
          [-46.699354, -23.702339],
          [-46.69952, -23.702245],
          [-46.699639, -23.70216],
          [-46.699715, -23.702066],
          [-46.699763, -23.701962],
          [-46.69981, -23.701863],
          [-46.699852, -23.701726],
          [-46.699994, -23.700996],
          [-46.700006, -23.700746],
          [-46.699982, -23.700656],
          [-46.699946, -23.700586],
          [-46.699893, -23.700529],
          [-46.699834, -23.70051],
          [-46.699781, -23.700496],
          [-46.699704, -23.700496],
          [-46.699621, -23.700515],
          [-46.699538, -23.700548],
          [-46.69936, -23.700666],
          [-46.69923, -23.700746],
          [-46.699147, -23.700774],
          [-46.699041, -23.700788],
          [-46.698946, -23.700784],
          [-46.698869, -23.700765],
          [-46.698763, -23.700718],
          [-46.698692, -23.700656],
          [-46.698632, -23.700571],
          [-46.698597, -23.700477],
          [-46.698585, -23.700369],
          [-46.698597, -23.700284],
          [-46.698644, -23.700204],
          [-46.698709, -23.700138],
          [-46.698816, -23.700034],
          [-46.699278, -23.699615],
          [-46.699402, -23.699454],
          [-46.699467, -23.699308],
          [-46.699526, -23.699171],
          [-46.699585, -23.698964],
          [-46.69965, -23.698677],
          [-46.69965, -23.698587],
          [-46.699633, -23.698516],
          [-46.699591, -23.69846],
          [-46.699538, -23.698417],
          [-46.699479, -23.698398],
          [-46.699402, -23.698389],
          [-46.699343, -23.698403],
          [-46.699289, -23.698431],
          [-46.699224, -23.698479],
          [-46.698644, -23.699068],
          [-46.698508, -23.699181],
          [-46.69839, -23.699256],
          [-46.698265, -23.699322],
          [-46.698153, -23.69936],
          [-46.698005, -23.699384],
          [-46.697839, -23.699388],
          [-46.697662, -23.699365],
          [-46.697502, -23.699308],
          [-46.697372, -23.699237],
          [-46.697241, -23.699153],
          [-46.697111, -23.699021],
          [-46.697016, -23.698898],
          [-46.696194, -23.697691],
          [-46.696146, -23.697616],
          [-46.696129, -23.697545],
          [-46.69614, -23.697479],
          [-46.696176, -23.697423],
          [-46.696241, -23.697361],
          [-46.696318, -23.69731],
          [-46.696401, -23.697267],
          [-46.696502, -23.697225],
          [-46.697093, -23.697036],
          [-46.697212, -23.697008],
          [-46.69733, -23.696989],
          [-46.697454, -23.696984],
          [-46.697573, -23.696998],
          [-46.698088, -23.697088],
          [-46.698289, -23.69713],
          [-46.698484, -23.697196],
          [-46.698774, -23.697305],
          [-46.699147, -23.697474],
          [-46.699301, -23.697555],
          [-46.699461, -23.697658],
          [-46.699597, -23.697781],
          [-46.699721, -23.697913],
          [-46.699828, -23.698073],
          [-46.699905, -23.698219],
          [-46.699988, -23.698422],
          [-46.700071, -23.69871],
          [-46.700515, -23.700397],
          [-46.700556, -23.700595],
          [-46.700591, -23.700845],
          [-46.700609, -23.70109],
          [-46.700603, -23.701326],
          [-46.700574, -23.701538],
          [-46.70052, -23.701731],
          [-46.700118, -23.703192],
          [-46.69997, -23.703753]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'ae-2009',
        Location: 'Abu Dhabi',
        Name: 'Yas Marina Circuit',
        opened: 2009,
        firstgp: 2009,
        length: 5554,
        altitude: 9
      },
      bbox: [54.601568, 24.463041, 54.609783, 24.479015],
      geometry: {
        type: 'LineString',
        coordinates: [
          [54.605463, 24.46997],
          [54.60783, 24.470262],
          [54.607955, 24.4703],
          [54.608049, 24.470389],
          [54.608114, 24.470512],
          [54.608126, 24.470634],
          [54.608091, 24.470762],
          [54.607712, 24.472228],
          [54.607647, 24.472388],
          [54.607558, 24.472506],
          [54.60741, 24.472619],
          [54.607286, 24.472675],
          [54.606593, 24.472892],
          [54.606392, 24.472968],
          [54.606226, 24.473071],
          [54.605989, 24.473265],
          [54.605871, 24.473392],
          [54.60577, 24.473585],
          [54.605717, 24.473797],
          [54.605717, 24.474038],
          [54.605747, 24.474198],
          [54.605806, 24.474396],
          [54.606001, 24.475098],
          [54.606043, 24.475376],
          [54.606049, 24.475697],
          [54.606025, 24.476013],
          [54.605841, 24.477535],
          [54.605824, 24.477611],
          [54.605753, 24.477639],
          [54.605427, 24.477696],
          [54.605338, 24.477752],
          [54.605303, 24.477846],
          [54.605315, 24.477912],
          [54.605327, 24.477969],
          [54.605652, 24.478756],
          [54.605682, 24.478841],
          [54.605658, 24.478916],
          [54.605622, 24.478949],
          [54.605563, 24.478997],
          [54.605451, 24.479015],
          [54.60535, 24.478982],
          [54.605285, 24.478907],
          [54.603563, 24.474212],
          [54.602764, 24.472082],
          [54.602379, 24.470837],
          [54.60203, 24.469838],
          [54.601627, 24.46873],
          [54.60158, 24.468622],
          [54.601568, 24.468541],
          [54.60158, 24.468494],
          [54.601615, 24.468452],
          [54.601746, 24.468443],
          [54.602148, 24.46849],
          [54.602207, 24.468471],
          [54.602249, 24.468433],
          [54.602438, 24.467726],
          [54.602598, 24.467311],
          [54.602693, 24.467137],
          [54.602805, 24.466948],
          [54.603036, 24.466665],
          [54.60335, 24.466321],
          [54.603651, 24.46609],
          [54.605403, 24.464822],
          [54.605806, 24.46454],
          [54.606279, 24.464247],
          [54.606806, 24.46396],
          [54.607807, 24.463535],
          [54.608973, 24.463055],
          [54.609061, 24.463041],
          [54.60915, 24.463088],
          [54.609192, 24.463187],
          [54.609274, 24.463493],
          [54.609316, 24.463568],
          [54.609369, 24.463611],
          [54.609434, 24.463634],
          [54.609665, 24.463649],
          [54.609736, 24.463696],
          [54.609778, 24.463757],
          [54.609783, 24.464257],
          [54.60976, 24.464869],
          [54.609724, 24.46494],
          [54.609624, 24.464997],
          [54.609547, 24.465001],
          [54.607055, 24.464672],
          [54.606907, 24.464672],
          [54.6068, 24.46469],
          [54.606688, 24.464737],
          [54.605717, 24.465308],
          [54.605599, 24.465435],
          [54.60554, 24.465562],
          [54.605498, 24.465685],
          [54.605327, 24.466477],
          [54.605344, 24.466557],
          [54.605427, 24.466599],
          [54.605492, 24.466623],
          [54.606303, 24.466713],
          [54.606422, 24.466746],
          [54.606469, 24.466793],
          [54.606504, 24.466878],
          [54.606469, 24.467783],
          [54.60641, 24.467839],
          [54.606333, 24.467877],
          [54.605889, 24.467919],
          [54.605717, 24.467929],
          [54.603723, 24.46766],
          [54.603598, 24.467665],
          [54.603474, 24.467726],
          [54.603385, 24.46783],
          [54.602693, 24.468999],
          [54.602639, 24.46915],
          [54.602616, 24.469272],
          [54.602604, 24.469423],
          [54.602628, 24.469513],
          [54.602693, 24.469569],
          [54.602758, 24.469602],
          [54.602876, 24.469621],
          [54.605463, 24.46997]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'it-1953',
        Location: 'Imola',
        Name: 'Autodromo Enzo e Dino Ferrari',
        opened: 1953,
        firstgp: 1980,
        length: 4909,
        altitude: 47
      },
      bbox: [11.702032, 44.336508, 11.725155, 44.345054],
      geometry: {
        type: 'LineString',
        coordinates: [
          [11.716701, 44.344056],
          [11.716291, 44.34406],
          [11.713733, 44.344453],
          [11.71282, 44.344522],
          [11.712288, 44.344526],
          [11.709619, 44.344355],
          [11.708308, 44.344133],
          [11.708145, 44.344056],
          [11.708067, 44.343987],
          [11.708044, 44.343923],
          [11.707948, 44.343624],
          [11.707877, 44.343529],
          [11.707714, 44.343448],
          [11.706508, 44.343009],
          [11.706328, 44.342865],
          [11.704382, 44.339415],
          [11.704359, 44.339323],
          [11.704362, 44.339211],
          [11.704568, 44.338675],
          [11.704568, 44.33859],
          [11.704501, 44.338486],
          [11.704426, 44.338415],
          [11.702122, 44.337005],
          [11.702056, 44.336924],
          [11.702032, 44.336828],
          [11.702061, 44.336725],
          [11.702146, 44.336602],
          [11.702256, 44.336535],
          [11.702381, 44.336508],
          [11.702573, 44.33651],
          [11.706288, 44.336855],
          [11.706711, 44.336876],
          [11.707336, 44.336851],
          [11.707789, 44.336804],
          [11.708406, 44.33672],
          [11.709039, 44.336637],
          [11.709367, 44.336591],
          [11.709574, 44.336621],
          [11.709731, 44.336677],
          [11.709934, 44.336818],
          [11.710138, 44.337082],
          [11.710451, 44.337641],
          [11.710524, 44.337886],
          [11.710547, 44.338164],
          [11.710486, 44.338447],
          [11.710033, 44.339981],
          [11.710039, 44.340077],
          [11.710103, 44.340187],
          [11.710367, 44.340484],
          [11.710712, 44.340868],
          [11.710813, 44.340905],
          [11.710947, 44.340915],
          [11.71104, 44.340886],
          [11.711551, 44.340739],
          [11.711708, 44.340724],
          [11.717065, 44.340749],
          [11.717134, 44.340728],
          [11.717201, 44.340614],
          [11.717251, 44.340514],
          [11.717309, 44.340489],
          [11.717422, 44.340487],
          [11.719561, 44.341117],
          [11.719831, 44.341225],
          [11.720722, 44.341665],
          [11.721232, 44.341997],
          [11.721726, 44.342352],
          [11.722932, 44.343198],
          [11.723176, 44.343322],
          [11.723441, 44.343415],
          [11.725019, 44.343916],
          [11.725138, 44.343999],
          [11.725155, 44.34413],
          [11.725123, 44.344234],
          [11.724647, 44.344954],
          [11.724536, 44.345022],
          [11.724414, 44.345049],
          [11.724243, 44.345054],
          [11.724106, 44.345029],
          [11.721985, 44.344453],
          [11.721232, 44.344245],
          [11.720822, 44.344139],
          [11.720465, 44.344081],
          [11.720224, 44.34405],
          [11.716701, 44.344056]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'de-1927',
        Location: 'Nürburg',
        Name: 'Nürburgring',
        opened: 1927,
        firstgp: 1984,
        length: 5148,
        altitude: 627
      },
      bbox: [6.934135, 50.323947, 6.949985, 50.337712],
      geometry: {
        type: 'LineString',
        coordinates: [
          [6.947632, 50.335537],
          [6.943719, 50.332988],
          [6.942907, 50.332478],
          [6.942516, 50.332285],
          [6.942135, 50.332104],
          [6.941286, 50.331732],
          [6.941108, 50.331717],
          [6.940995, 50.331756],
          [6.940938, 50.331846],
          [6.940976, 50.331975],
          [6.941093, 50.33226],
          [6.941281, 50.332509],
          [6.941654, 50.332942],
          [6.941684, 50.333045],
          [6.941675, 50.333175],
          [6.941605, 50.333317],
          [6.941453, 50.333449],
          [6.941298, 50.333536],
          [6.941111, 50.333597],
          [6.940896, 50.333625],
          [6.940748, 50.333621],
          [6.939849, 50.333536],
          [6.93944, 50.333465],
          [6.939077, 50.333391],
          [6.93881, 50.333286],
          [6.938663, 50.3332],
          [6.9386, 50.333111],
          [6.938597, 50.332978],
          [6.93864, 50.332849],
          [6.93882, 50.33274],
          [6.939061, 50.332695],
          [6.939491, 50.332709],
          [6.939728, 50.332703],
          [6.939866, 50.332661],
          [6.939997, 50.332565],
          [6.940023, 50.332453],
          [6.939988, 50.332176],
          [6.939913, 50.331765],
          [6.939732, 50.331097],
          [6.939634, 50.330758],
          [6.939545, 50.330467],
          [6.939461, 50.330271],
          [6.939108, 50.32959],
          [6.938795, 50.328934],
          [6.93869, 50.328731],
          [6.938671, 50.328629],
          [6.938659, 50.328532],
          [6.938704, 50.328405],
          [6.938776, 50.328297],
          [6.938884, 50.328187],
          [6.939042, 50.32809],
          [6.939154, 50.328044],
          [6.939627, 50.3279],
          [6.940192, 50.327734],
          [6.940356, 50.327656],
          [6.940445, 50.327566],
          [6.940487, 50.327486],
          [6.940494, 50.327389],
          [6.94048, 50.327335],
          [6.940426, 50.327215],
          [6.940248, 50.327105],
          [6.939541, 50.326866],
          [6.938607, 50.326529],
          [6.938162, 50.326343],
          [6.937717, 50.326141],
          [6.937029, 50.325742],
          [6.936664, 50.325513],
          [6.936325, 50.325246],
          [6.935997, 50.324974],
          [6.935699, 50.324692],
          [6.935158, 50.324106],
          [6.934986, 50.323994],
          [6.934792, 50.323949],
          [6.934624, 50.323947],
          [6.934439, 50.323983],
          [6.934282, 50.324058],
          [6.934174, 50.324159],
          [6.934135, 50.324278],
          [6.934139, 50.324393],
          [6.934209, 50.324508],
          [6.934495, 50.324693],
          [6.936805, 50.326167],
          [6.937077, 50.326341],
          [6.93718, 50.326443],
          [6.937276, 50.326582],
          [6.937344, 50.326745],
          [6.937358, 50.326964],
          [6.937304, 50.327159],
          [6.937145, 50.327463],
          [6.937105, 50.327619],
          [6.937105, 50.327877],
          [6.937176, 50.328086],
          [6.938193, 50.330114],
          [6.938635, 50.330998],
          [6.938785, 50.331344],
          [6.938757, 50.331459],
          [6.938647, 50.331593],
          [6.938567, 50.33165],
          [6.938462, 50.331687],
          [6.936717, 50.33218],
          [6.936517, 50.33229],
          [6.936409, 50.332399],
          [6.936348, 50.332529],
          [6.936334, 50.332709],
          [6.936377, 50.332827],
          [6.936479, 50.332958],
          [6.936718, 50.333154],
          [6.938202, 50.3343],
          [6.939672, 50.335443],
          [6.939831, 50.335524],
          [6.940034, 50.335618],
          [6.940308, 50.335701],
          [6.941366, 50.335895],
          [6.946036, 50.336678],
          [6.946094, 50.336714],
          [6.946101, 50.336772],
          [6.946059, 50.336868],
          [6.94602, 50.336984],
          [6.946052, 50.337066],
          [6.946251, 50.337141],
          [6.947042, 50.337371],
          [6.947536, 50.33746],
          [6.94923, 50.337712],
          [6.949476, 50.337712],
          [6.949701, 50.337641],
          [6.949868, 50.337524],
          [6.949952, 50.337417],
          [6.949985, 50.337315],
          [6.949983, 50.337164],
          [6.949908, 50.337021],
          [6.947668, 50.33556],
          [6.947668, 50.33556],
          [6.947632, 50.335537]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'pt-2008',
        Location: 'Portimão',
        Name: 'Autódromo Internacional do Algarve',
        opened: 2008,
        firstgp: 2020,
        length: 4653,
        altitude: 44
      },
      bbox: [-8.632049, 37.226074, -8.624377, 37.236482],
      geometry: {
        type: 'LineString',
        coordinates: [
          [-8.63081, 37.232113],
          [-8.631815, 37.234859],
          [-8.632041, 37.235513],
          [-8.632049, 37.235595],
          [-8.631996, 37.235671],
          [-8.631891, 37.235755],
          [-8.631758, 37.235822],
          [-8.631123, 37.236199],
          [-8.630678, 37.236447],
          [-8.630527, 37.236482],
          [-8.630409, 37.236476],
          [-8.628977, 37.236198],
          [-8.628899, 37.236141],
          [-8.628867, 37.236078],
          [-8.628858, 37.236019],
          [-8.628882, 37.235947],
          [-8.628967, 37.235878],
          [-8.629783, 37.235495],
          [-8.629907, 37.235413],
          [-8.63001, 37.235294],
          [-8.630043, 37.235222],
          [-8.630083, 37.235102],
          [-8.630067, 37.23491],
          [-8.628503, 37.230556],
          [-8.628422, 37.230361],
          [-8.62832, 37.230292],
          [-8.628209, 37.23029],
          [-8.628101, 37.230338],
          [-8.628037, 37.230421],
          [-8.62802, 37.230589],
          [-8.62785, 37.231867],
          [-8.627827, 37.232122],
          [-8.627869, 37.232417],
          [-8.627945, 37.232622],
          [-8.628048, 37.232807],
          [-8.628841, 37.234007],
          [-8.628882, 37.23414],
          [-8.628863, 37.234285],
          [-8.628806, 37.234412],
          [-8.628668, 37.234564],
          [-8.628059, 37.23514],
          [-8.627969, 37.235169],
          [-8.627867, 37.235182],
          [-8.627713, 37.235158],
          [-8.627589, 37.23509],
          [-8.627528, 37.235006],
          [-8.627048, 37.232373],
          [-8.627018, 37.232255],
          [-8.626941, 37.232108],
          [-8.626867, 37.231992],
          [-8.626697, 37.231844],
          [-8.626455, 37.23171],
          [-8.624838, 37.231048],
          [-8.624702, 37.230945],
          [-8.624545, 37.230766],
          [-8.624399, 37.230464],
          [-8.624377, 37.23034],
          [-8.624403, 37.23024],
          [-8.624457, 37.230172],
          [-8.624558, 37.230099],
          [-8.626289, 37.229678],
          [-8.626401, 37.22963],
          [-8.626561, 37.229525],
          [-8.626732, 37.229375],
          [-8.626857, 37.22919],
          [-8.626917, 37.228977],
          [-8.627125, 37.227874],
          [-8.627108, 37.227771],
          [-8.627039, 37.227694],
          [-8.626926, 37.227606],
          [-8.626759, 37.227589],
          [-8.626623, 37.227611],
          [-8.626562, 37.227649],
          [-8.625486, 37.228686],
          [-8.625331, 37.228749],
          [-8.625166, 37.228777],
          [-8.624956, 37.228737],
          [-8.624784, 37.228615],
          [-8.62466, 37.228478],
          [-8.62461, 37.22838],
          [-8.624559, 37.228179],
          [-8.624564, 37.228064],
          [-8.624596, 37.227931],
          [-8.624674, 37.227798],
          [-8.62489, 37.22756],
          [-8.625977, 37.226518],
          [-8.626212, 37.22636],
          [-8.626421, 37.226249],
          [-8.626588, 37.226185],
          [-8.626848, 37.226112],
          [-8.627093, 37.226075],
          [-8.627402, 37.226074],
          [-8.627644, 37.226104],
          [-8.627888, 37.226156],
          [-8.628129, 37.226246],
          [-8.62837, 37.226357],
          [-8.628568, 37.226509],
          [-8.628733, 37.226661],
          [-8.628909, 37.226867],
          [-8.630778, 37.232024],
          [-8.63081, 37.232113]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'it-1914',
        Location: 'Scarperia e San Piero',
        Name: 'Autodromo Internazionale del Mugello',
        opened: 1914,
        firstgp: 2020,
        length: 5245,
        altitude: 292
      },
      bbox: [11.365772, 43.991538, 11.377272, 44.003271],
      geometry: {
        type: 'LineString',
        coordinates: [
          [11.371465, 43.997589],
          [11.371893, 43.998272],
          [11.372286, 43.998858],
          [11.373086, 43.999838],
          [11.37373, 44.000646],
          [11.374286, 44.001551],
          [11.375048, 44.002955],
          [11.375166, 44.003094],
          [11.375286, 44.003174],
          [11.375419, 44.003241],
          [11.375679, 44.003271],
          [11.375899, 44.003243],
          [11.376077, 44.003165],
          [11.376209, 44.00305],
          [11.376303, 44.002916],
          [11.376312, 44.002647],
          [11.376255, 44.002362],
          [11.376053, 44.001572],
          [11.376045, 44.001471],
          [11.376076, 44.001383],
          [11.376149, 44.00128],
          [11.376263, 44.001197],
          [11.376569, 44.001065],
          [11.377074, 44.000827],
          [11.377188, 44.000714],
          [11.37725, 44.000573],
          [11.377272, 44.000453],
          [11.377264, 44.000329],
          [11.3772, 44.000189],
          [11.377079, 44.000038],
          [11.374858, 43.997607],
          [11.374812, 43.997513],
          [11.374796, 43.997426],
          [11.374802, 43.99735],
          [11.374825, 43.997272],
          [11.374893, 43.997142],
          [11.375125, 43.996789],
          [11.37517, 43.996671],
          [11.37517, 43.996569],
          [11.375146, 43.996463],
          [11.375096, 43.996365],
          [11.375035, 43.996286],
          [11.374865, 43.996119],
          [11.372755, 43.994265],
          [11.372659, 43.994204],
          [11.372537, 43.994143],
          [11.372412, 43.994105],
          [11.372308, 43.994083],
          [11.372188, 43.994079],
          [11.371064, 43.994085],
          [11.370919, 43.994067],
          [11.37067, 43.994],
          [11.370483, 43.993913],
          [11.370339, 43.993822],
          [11.370219, 43.993704],
          [11.370105, 43.993561],
          [11.370026, 43.99342],
          [11.369518, 43.992379],
          [11.369443, 43.992225],
          [11.36935, 43.992074],
          [11.369206, 43.991916],
          [11.369076, 43.991804],
          [11.368887, 43.991695],
          [11.36871, 43.991615],
          [11.368467, 43.991561],
          [11.368234, 43.991538],
          [11.367996, 43.991546],
          [11.367676, 43.991597],
          [11.367526, 43.991623],
          [11.36736, 43.991669],
          [11.366373, 43.992042],
          [11.366203, 43.992119],
          [11.366027, 43.992252],
          [11.365916, 43.992375],
          [11.365817, 43.992527],
          [11.365772, 43.992713],
          [11.365772, 43.992849],
          [11.365809, 43.993109],
          [11.366415, 43.995373],
          [11.366454, 43.995458],
          [11.366544, 43.995572],
          [11.366677, 43.995645],
          [11.36681, 43.995696],
          [11.367028, 43.99572],
          [11.367771, 43.995725],
          [11.367917, 43.995745],
          [11.36805, 43.995787],
          [11.36818, 43.995858],
          [11.36834, 43.995994],
          [11.368428, 43.996163],
          [11.369484, 43.998825],
          [11.369548, 43.998952],
          [11.369675, 43.999092],
          [11.369824, 43.999197],
          [11.369976, 43.999261],
          [11.370159, 43.999295],
          [11.370341, 43.999294],
          [11.37056, 43.999256],
          [11.370771, 43.999159],
          [11.370917, 43.999035],
          [11.370987, 43.998908],
          [11.371027, 43.998732],
          [11.370996, 43.998574],
          [11.370891, 43.998379],
          [11.37059, 43.998047],
          [11.369926, 43.997458],
          [11.369872, 43.997371],
          [11.369831, 43.997272],
          [11.369816, 43.997148],
          [11.369815, 43.996577],
          [11.369782, 43.996485],
          [11.369643, 43.996316],
          [11.366746, 43.99351],
          [11.366688, 43.993408],
          [11.366609, 43.993274],
          [11.366584, 43.993166],
          [11.366588, 43.992953],
          [11.366638, 43.992831],
          [11.366767, 43.992669],
          [11.366933, 43.992556],
          [11.367197, 43.992457],
          [11.367394, 43.992439],
          [11.367687, 43.992459],
          [11.367947, 43.992529],
          [11.368181, 43.992646],
          [11.368422, 43.99282],
          [11.368667, 43.993091],
          [11.369534, 43.994472],
          [11.371465, 43.997589]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'my-1999',
        Location: 'Sepang',
        Name: 'Sepang International Circuit',
        opened: 1999,
        firstgp: 1999,
        length: 5543,
        altitude: 39
      },
      bbox: [101.732582, 2.756603, 101.74303, 2.765153],
      geometry: {
        type: 'LineString',
        coordinates: [
          [101.735641, 2.760529],
          [101.732942, 2.760307],
          [101.732818, 2.760317],
          [101.732706, 2.760373],
          [101.732629, 2.760454],
          [101.732587, 2.760564],
          [101.732582, 2.760688],
          [101.732627, 2.760818],
          [101.732732, 2.760916],
          [101.732874, 2.760961],
          [101.73304, 2.760928],
          [101.733348, 2.760818],
          [101.733451, 2.760835],
          [101.733538, 2.760921],
          [101.733566, 2.761026],
          [101.733538, 2.761164],
          [101.733446, 2.761304],
          [101.733236, 2.761561],
          [101.733147, 2.761718],
          [101.733089, 2.761904],
          [101.733061, 2.762091],
          [101.733061, 2.762303],
          [101.733112, 2.762825],
          [101.733194, 2.76307],
          [101.733323, 2.76332],
          [101.733453, 2.763481],
          [101.733653, 2.763662],
          [101.733863, 2.7638],
          [101.734083, 2.763881],
          [101.735319, 2.764284],
          [101.736244, 2.764648],
          [101.736863, 2.764916],
          [101.737262, 2.765097],
          [101.7374, 2.765153],
          [101.737503, 2.765149],
          [101.737592, 2.765093],
          [101.737624, 2.764981],
          [101.737796, 2.764022],
          [101.737901, 2.763528],
          [101.738049, 2.762929],
          [101.738157, 2.762698],
          [101.738278, 2.762533],
          [101.738486, 2.762367],
          [101.738692, 2.762257],
          [101.738897, 2.762206],
          [101.739098, 2.762197],
          [101.739327, 2.762232],
          [101.739561, 2.762323],
          [101.739727, 2.762442],
          [101.740051, 2.762789],
          [101.74021, 2.762885],
          [101.74046, 2.762971],
          [101.740673, 2.762978],
          [101.740883, 2.76295],
          [101.741053, 2.76288],
          [101.741205, 2.762759],
          [101.74302, 2.760691],
          [101.74303, 2.76059],
          [101.742988, 2.760475],
          [101.742679, 2.759782],
          [101.742586, 2.759717],
          [101.742476, 2.759691],
          [101.740819, 2.759595],
          [101.739263, 2.759413],
          [101.73841, 2.759273],
          [101.738329, 2.759207],
          [101.738303, 2.759098],
          [101.738375, 2.758976],
          [101.738983, 2.75864],
          [101.739116, 2.758506],
          [101.739209, 2.758308],
          [101.739256, 2.758102],
          [101.739249, 2.757808],
          [101.739209, 2.757561],
          [101.739154, 2.75732],
          [101.739009, 2.757012],
          [101.738792, 2.756697],
          [101.738673, 2.756622],
          [101.738559, 2.756603],
          [101.73843, 2.756627],
          [101.738327, 2.756694],
          [101.736426, 2.758259],
          [101.736293, 2.758308],
          [101.736122, 2.758318],
          [101.735935, 2.758271],
          [101.735242, 2.757916],
          [101.735057, 2.757858],
          [101.734837, 2.757828],
          [101.734644, 2.75783],
          [101.734284, 2.757895],
          [101.734039, 2.757996],
          [101.73388, 2.758122],
          [101.733667, 2.758402],
          [101.733592, 2.758612],
          [101.733581, 2.75874],
          [101.73367, 2.758884],
          [101.733861, 2.758963],
          [101.7414, 2.760348],
          [101.741508, 2.760443],
          [101.741587, 2.760625],
          [101.741547, 2.760777],
          [101.74141, 2.760919],
          [101.741185, 2.760954],
          [101.735641, 2.760529]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'tr-2005',
        Location: 'Istanbul',
        Name: 'Intercity Istanbul Park',
        opened: 2005,
        firstgp: 2005,
        length: 5338,
        altitude: 150
      },
      bbox: [29.400023, 40.951405, 29.417419, 40.962944],
      geometry: {
        type: 'LineString',
        coordinates: [
          [29.406152, 40.952131],
          [29.40884, 40.952581],
          [29.409051, 40.952654],
          [29.409149, 40.952798],
          [29.409122, 40.952916],
          [29.408948, 40.95346],
          [29.408845, 40.953746],
          [29.408845, 40.953959],
          [29.408916, 40.954264],
          [29.40916, 40.954591],
          [29.409561, 40.954882],
          [29.410371, 40.955244],
          [29.410839, 40.955391],
          [29.411422, 40.955538],
          [29.412489, 40.955691],
          [29.413171, 40.955715],
          [29.413552, 40.955718],
          [29.414094, 40.955659],
          [29.41433, 40.955684],
          [29.414586, 40.955771],
          [29.41483, 40.955955],
          [29.414954, 40.956171],
          [29.415008, 40.956382],
          [29.414892, 40.95705],
          [29.414921, 40.957185],
          [29.415045, 40.957272],
          [29.415235, 40.957272],
          [29.41581, 40.957219],
          [29.416319, 40.957219],
          [29.416592, 40.957272],
          [29.416712, 40.957378],
          [29.416739, 40.957505],
          [29.416598, 40.958093],
          [29.416507, 40.958224],
          [29.416329, 40.958327],
          [29.411953, 40.960008],
          [29.411676, 40.960167],
          [29.411577, 40.960317],
          [29.411585, 40.960464],
          [29.411639, 40.960591],
          [29.411763, 40.960691],
          [29.412131, 40.96086],
          [29.412446, 40.960916],
          [29.412714, 40.960929],
          [29.41405, 40.960744],
          [29.415155, 40.960548],
          [29.415713, 40.960426],
          [29.415986, 40.960382],
          [29.41616, 40.960416],
          [29.417032, 40.960779],
          [29.41714, 40.960891],
          [29.417419, 40.961528],
          [29.417415, 40.961687],
          [29.417336, 40.961831],
          [29.417001, 40.962261],
          [29.416704, 40.96252],
          [29.416249, 40.962853],
          [29.416038, 40.962925],
          [29.415723, 40.962944],
          [29.415293, 40.962903],
          [29.409749, 40.961658],
          [29.409426, 40.961524],
          [29.409315, 40.961414],
          [29.409331, 40.961268],
          [29.409534, 40.961021],
          [29.40967, 40.960812],
          [29.40967, 40.960577],
          [29.407904, 40.956441],
          [29.407685, 40.956229],
          [29.40734, 40.955986],
          [29.400185, 40.953056],
          [29.400052, 40.95295],
          [29.400023, 40.952806],
          [29.400056, 40.952672],
          [29.400205, 40.952531],
          [29.400362, 40.952487],
          [29.400838, 40.952516],
          [29.40097, 40.952472],
          [29.401037, 40.952397],
          [29.40102, 40.952228],
          [29.400884, 40.951605],
          [29.400904, 40.951486],
          [29.401016, 40.951405],
          [29.401177, 40.951405],
          [29.406152, 40.952131]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'nl-1948',
        Location: 'Zandvoort',
        Name: 'Circuit Zandvoort',
        opened: 1948,
        firstgp: 1952,
        length: 4259,
        altitude: 3
      },
      bbox: [4.538742, 52.384363, 4.553061, 52.391811],
      geometry: {
        type: 'LineString',
        coordinates: [
          [4.540491, 52.388408],
          [4.542096, 52.390776],
          [4.542706, 52.391645],
          [4.542844, 52.391741],
          [4.543031, 52.391795],
          [4.543235, 52.391811],
          [4.543424, 52.391787],
          [4.543602, 52.391713],
          [4.543726, 52.39162],
          [4.543792, 52.391504],
          [4.543797, 52.391375],
          [4.543703, 52.391196],
          [4.54322, 52.390485],
          [4.543082, 52.390244],
          [4.542999, 52.390097],
          [4.542945, 52.389901],
          [4.542933, 52.38977],
          [4.542916, 52.389305],
          [4.542884, 52.389206],
          [4.542812, 52.389101],
          [4.542686, 52.389017],
          [4.542545, 52.388945],
          [4.542333, 52.388894],
          [4.541332, 52.388679],
          [4.541163, 52.38862],
          [4.541065, 52.38856],
          [4.540985, 52.388465],
          [4.540962, 52.388371],
          [4.540979, 52.38826],
          [4.541057, 52.388166],
          [4.541189, 52.388099],
          [4.541372, 52.388054],
          [4.54166, 52.388048],
          [4.543319, 52.388362],
          [4.543889, 52.388429],
          [4.544461, 52.38844],
          [4.544886, 52.388431],
          [4.545313, 52.388396],
          [4.545704, 52.388343],
          [4.546236, 52.388274],
          [4.546727, 52.388248],
          [4.54703, 52.388261],
          [4.547345, 52.388306],
          [4.547868, 52.388435],
          [4.548539, 52.388702],
          [4.548912, 52.388814],
          [4.549267, 52.388879],
          [4.549705, 52.388922],
          [4.550112, 52.388928],
          [4.551709, 52.388868],
          [4.55204, 52.388831],
          [4.552355, 52.388752],
          [4.552606, 52.388633],
          [4.552811, 52.388493],
          [4.552958, 52.388343],
          [4.553036, 52.38817],
          [4.553061, 52.387987],
          [4.553033, 52.387808],
          [4.552947, 52.387626],
          [4.552761, 52.387428],
          [4.551997, 52.386746],
          [4.551778, 52.386498],
          [4.551194, 52.38579],
          [4.550967, 52.385721],
          [4.550557, 52.385704],
          [4.55022, 52.385714],
          [4.549823, 52.385755],
          [4.549411, 52.385841],
          [4.54897, 52.38597],
          [4.548533, 52.38616],
          [4.548263, 52.386343],
          [4.548214, 52.386455],
          [4.548257, 52.386573],
          [4.548419, 52.386687],
          [4.548741, 52.386812],
          [4.548952, 52.386859],
          [4.549582, 52.386926],
          [4.550139, 52.387016],
          [4.550808, 52.387175],
          [4.551025, 52.387291],
          [4.551136, 52.387442],
          [4.551151, 52.387607],
          [4.551056, 52.387771],
          [4.550811, 52.38792],
          [4.550591, 52.387967],
          [4.549376, 52.388042],
          [4.548249, 52.388019],
          [4.547096, 52.387935],
          [4.546101, 52.387788],
          [4.54551, 52.387674],
          [4.544815, 52.387525],
          [4.544102, 52.387336],
          [4.543469, 52.387144],
          [4.543267, 52.387091],
          [4.543123, 52.387108],
          [4.542988, 52.387222],
          [4.542844, 52.387388],
          [4.542646, 52.387463],
          [4.542392, 52.387469],
          [4.542144, 52.387398],
          [4.542012, 52.387289],
          [4.541951, 52.387172],
          [4.542012, 52.386934],
          [4.542566, 52.38496],
          [4.542578, 52.384828],
          [4.542517, 52.384693],
          [4.542419, 52.384579],
          [4.542324, 52.384506],
          [4.542089, 52.384409],
          [4.541838, 52.384374],
          [4.540774, 52.384363],
          [4.540557, 52.38437],
          [4.540241, 52.3844],
          [4.539914, 52.384465],
          [4.539645, 52.38454],
          [4.539287, 52.384712],
          [4.539054, 52.384902],
          [4.538895, 52.385065],
          [4.538779, 52.385285],
          [4.538742, 52.385478],
          [4.538775, 52.385793],
          [4.538873, 52.386017],
          [4.540408, 52.38829],
          [4.540491, 52.388408]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'fr-1960',
        Location: 'Magny-Cours',
        Name: 'Circuit de Nevers Magny-Cours',
        opened: 1960,
        firstgp: 1991,
        length: 4412,
        altitude: 230
      },
      bbox: [3.160075, 46.859125, 3.169239, 46.868387],
      geometry: {
        type: 'LineString',
        coordinates: [
          [3.16371, 46.864076],
          [3.165739, 46.865204],
          [3.165897, 46.86539],
          [3.165972, 46.865539],
          [3.165991, 46.866053],
          [3.165983, 46.866711],
          [3.165916, 46.866828],
          [3.165724, 46.867081],
          [3.165631, 46.867377],
          [3.165646, 46.867582],
          [3.165682, 46.86768],
          [3.165802, 46.867898],
          [3.165989, 46.868066],
          [3.166202, 46.868195],
          [3.166392, 46.868283],
          [3.166687, 46.868361],
          [3.167003, 46.868387],
          [3.167277, 46.868381],
          [3.167598, 46.868312],
          [3.16783, 46.86821],
          [3.167998, 46.868097],
          [3.168192, 46.867901],
          [3.168645, 46.867246],
          [3.168865, 46.866859],
          [3.168976, 46.86656],
          [3.169031, 46.86633],
          [3.169239, 46.864033],
          [3.169239, 46.863793],
          [3.169188, 46.863342],
          [3.169097, 46.862975],
          [3.167903, 46.859974],
          [3.167834, 46.859889],
          [3.167705, 46.859873],
          [3.167615, 46.859912],
          [3.167562, 46.859997],
          [3.167373, 46.860863],
          [3.167624, 46.862048],
          [3.167666, 46.862205],
          [3.167584, 46.864608],
          [3.167605, 46.864684],
          [3.167694, 46.864763],
          [3.167953, 46.86493],
          [3.168075, 46.865051],
          [3.168172, 46.865245],
          [3.168204, 46.865428],
          [3.168191, 46.865796],
          [3.168077, 46.866289],
          [3.167879, 46.866767],
          [3.167715, 46.866952],
          [3.167502, 46.867086],
          [3.167256, 46.867147],
          [3.166963, 46.867107],
          [3.16682, 46.867007],
          [3.16674, 46.866912],
          [3.166742, 46.866777],
          [3.166795, 46.86666],
          [3.167068, 46.866376],
          [3.167139, 46.866262],
          [3.167207, 46.866063],
          [3.167221, 46.865821],
          [3.16715, 46.865592],
          [3.166847, 46.864933],
          [3.166786, 46.864741],
          [3.166744, 46.864557],
          [3.166788, 46.861659],
          [3.166725, 46.861561],
          [3.166198, 46.86116],
          [3.166146, 46.861066],
          [3.166125, 46.860788],
          [3.16613, 46.860617],
          [3.166182, 46.860276],
          [3.166252, 46.860077],
          [3.166619, 46.859239],
          [3.166576, 46.859181],
          [3.166323, 46.859125],
          [3.166068, 46.859148],
          [3.165818, 46.859217],
          [3.165459, 46.859393],
          [3.16513, 46.859592],
          [3.164774, 46.859887],
          [3.163459, 46.860921],
          [3.163145, 46.861131],
          [3.162629, 46.861395],
          [3.162142, 46.861555],
          [3.160138, 46.862008],
          [3.160081, 46.862058],
          [3.160075, 46.862139],
          [3.160296, 46.862418],
          [3.160748, 46.862775],
          [3.1609, 46.862841],
          [3.161014, 46.862791],
          [3.161115, 46.862732],
          [3.161218, 46.86272],
          [3.16153, 46.862877],
          [3.16371, 46.864076]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'pt-1972',
        Location: 'Estoril',
        Name: 'Autódromo do Estoril',
        opened: 1972,
        firstgp: 1984,
        length: 4349,
        altitude: 80
      },
      bbox: [-9.397381, 38.745536, -9.390192, 38.755309],
      geometry: {
        type: 'LineString',
        coordinates: [
          [-9.393073, 38.749017],
          [-9.395047, 38.745624],
          [-9.395129, 38.745561],
          [-9.39527, 38.745536],
          [-9.395393, 38.745558],
          [-9.395509, 38.745629],
          [-9.395908, 38.746138],
          [-9.396634, 38.746638],
          [-9.397219, 38.747004],
          [-9.397339, 38.74712],
          [-9.397381, 38.747227],
          [-9.397363, 38.747378],
          [-9.397071, 38.748146],
          [-9.396694, 38.748987],
          [-9.396598, 38.749083],
          [-9.396447, 38.749135],
          [-9.39626, 38.749119],
          [-9.396098, 38.749045],
          [-9.395985, 38.748918],
          [-9.39595, 38.748762],
          [-9.395989, 38.748478],
          [-9.396281, 38.74753],
          [-9.396267, 38.747409],
          [-9.396242, 38.747307],
          [-9.396137, 38.747192],
          [-9.395983, 38.747128],
          [-9.395853, 38.747107],
          [-9.395659, 38.747126],
          [-9.395507, 38.747205],
          [-9.395398, 38.747324],
          [-9.395349, 38.747442],
          [-9.394809, 38.749505],
          [-9.39476, 38.749596],
          [-9.394665, 38.749692],
          [-9.39139, 38.752927],
          [-9.391323, 38.753051],
          [-9.391323, 38.75315],
          [-9.391358, 38.753257],
          [-9.391464, 38.753378],
          [-9.39157, 38.753444],
          [-9.391757, 38.753502],
          [-9.391951, 38.753529],
          [-9.392148, 38.753529],
          [-9.39231, 38.753502],
          [-9.392494, 38.753439],
          [-9.392638, 38.753356],
          [-9.395054, 38.751007],
          [-9.395174, 38.750952],
          [-9.395344, 38.750922],
          [-9.395474, 38.75093],
          [-9.395619, 38.750963],
          [-9.395724, 38.751023],
          [-9.395841, 38.75112],
          [-9.395922, 38.751254],
          [-9.395978, 38.751403],
          [-9.396264, 38.753281],
          [-9.39626, 38.753399],
          [-9.396232, 38.753515],
          [-9.396172, 38.753638],
          [-9.39602, 38.753762],
          [-9.395795, 38.753878],
          [-9.395139, 38.754073],
          [-9.394325, 38.754249],
          [-9.393958, 38.754241],
          [-9.393278, 38.754081],
          [-9.393082, 38.754077],
          [-9.39292, 38.754135],
          [-9.392786, 38.754289],
          [-9.392529, 38.754847],
          [-9.392374, 38.755012],
          [-9.39213, 38.755166],
          [-9.391891, 38.755265],
          [-9.391535, 38.755309],
          [-9.391242, 38.755273],
          [-9.390911, 38.755174],
          [-9.390646, 38.755023],
          [-9.390435, 38.754833],
          [-9.390297, 38.754652],
          [-9.390213, 38.754399],
          [-9.390192, 38.754195],
          [-9.39023, 38.753953],
          [-9.39034, 38.753722],
          [-9.393073, 38.749017]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'br-1977',
        Location: 'Jacarepaguá',
        Name: 'Autódromo Internacional Nelson Piquet',
        opened: 1977,
        firstgp: 1978,
        length: 5031,
        altitude: 3
      },
      bbox: [-43.399859, -22.980204, -43.3893, -22.974123],
      geometry: {
        type: 'LineString',
        coordinates: [
          [-43.395225, -22.97485],
          [-43.392908, -22.974865],
          [-43.39259, -22.9749],
          [-43.392348, -22.975006],
          [-43.392132, -22.975221],
          [-43.392005, -22.975424],
          [-43.391941, -22.975658],
          [-43.391941, -22.97592],
          [-43.391996, -22.976174],
          [-43.39217, -22.976377],
          [-43.392344, -22.976545],
          [-43.392582, -22.976627],
          [-43.392709, -22.976639],
          [-43.393986, -22.976607],
          [-43.394207, -22.976683],
          [-43.394338, -22.976801],
          [-43.394436, -22.976933],
          [-43.394478, -22.977101],
          [-43.394482, -22.978515],
          [-43.394423, -22.978685],
          [-43.39433, -22.97881],
          [-43.394211, -22.978919],
          [-43.394003, -22.979021],
          [-43.393816, -22.97906],
          [-43.393596, -22.979072],
          [-43.393434, -22.97906],
          [-43.393171, -22.978927],
          [-43.391708, -22.977986],
          [-43.391112, -22.977425],
          [-43.39098, -22.9773],
          [-43.390959, -22.977198],
          [-43.390963, -22.975653],
          [-43.390887, -22.975493],
          [-43.390671, -22.975392],
          [-43.390391, -22.975364],
          [-43.39006, -22.97549],
          [-43.389843, -22.975561],
          [-43.389614, -22.975576],
          [-43.389432, -22.975443],
          [-43.3893, -22.975201],
          [-43.389309, -22.974955],
          [-43.389453, -22.974744],
          [-43.389657, -22.974592],
          [-43.389835, -22.974525],
          [-43.391515, -22.974201],
          [-43.396126, -22.974123],
          [-43.399036, -22.974201],
          [-43.399312, -22.974291],
          [-43.399541, -22.974432],
          [-43.399702, -22.974623],
          [-43.399796, -22.974842],
          [-43.399859, -22.975064],
          [-43.399855, -22.975252],
          [-43.399834, -22.975471],
          [-43.399796, -22.975666],
          [-43.399694, -22.975846],
          [-43.399554, -22.976029],
          [-43.399376, -22.976185],
          [-43.399168, -22.976314],
          [-43.398858, -22.976404],
          [-43.398459, -22.97649],
          [-43.39815, -22.976572],
          [-43.398048, -22.976668],
          [-43.397929, -22.97684],
          [-43.39791, -22.976991],
          [-43.397936, -22.977182],
          [-43.398199, -22.978499],
          [-43.398211, -22.978635],
          [-43.398207, -22.978807],
          [-43.398169, -22.978936],
          [-43.398097, -22.979084],
          [-43.398008, -22.979209],
          [-43.397897, -22.979291],
          [-43.396682, -22.98015],
          [-43.396538, -22.9802],
          [-43.396381, -22.980204],
          [-43.396194, -22.980161],
          [-43.396037, -22.980068],
          [-43.395884, -22.979892],
          [-43.395838, -22.97974],
          [-43.395787, -22.976738],
          [-43.39585, -22.976594],
          [-43.395961, -22.976496],
          [-43.39613, -22.97641],
          [-43.398809, -22.975821],
          [-43.398962, -22.9757],
          [-43.399055, -22.975536],
          [-43.399094, -22.975364],
          [-43.39903, -22.975173],
          [-43.398941, -22.975024],
          [-43.398784, -22.974907],
          [-43.398551, -22.974841],
          [-43.395225, -22.97485]
        ]
      }
    },
    {
      type: 'Feature',
      properties: {
        id: 'sa-2021',
        Location: 'Jeddah',
        Name: 'Jeddah Street Circuit',
        opened: 2021,
        firstgp: 2021,
        length: 6175,
        altitude: 12
      },
      bbox: [39.100896, 21.625405, 39.10643, 21.650217],
      geometry: {
        type: 'LineString',
        coordinates: [
          [39.105135, 21.631065],
          [39.103841, 21.634908],
          [39.103768, 21.634993],
          [39.103686, 21.635029],
          [39.10355, 21.634971],
          [39.10341, 21.634921],
          [39.103299, 21.634944],
          [39.103207, 21.63502],
          [39.103163, 21.63511],
          [39.103182, 21.635317],
          [39.103386, 21.635955],
          [39.103429, 21.636162],
          [39.103439, 21.636396],
          [39.1034, 21.636607],
          [39.103042, 21.638533],
          [39.103032, 21.63873],
          [39.103018, 21.638901],
          [39.102965, 21.638991],
          [39.102732, 21.639072],
          [39.102548, 21.639158],
          [39.102345, 21.639311],
          [39.10221, 21.639504],
          [39.102127, 21.63977],
          [39.102113, 21.640058],
          [39.10219, 21.640323],
          [39.102452, 21.6407],
          [39.102544, 21.640934],
          [39.102548, 21.641176],
          [39.102476, 21.641532],
          [39.102314, 21.6419],
          [39.102173, 21.642035],
          [39.101936, 21.642156],
          [39.101762, 21.642304],
          [39.101704, 21.642538],
          [39.101733, 21.64341],
          [39.101791, 21.643585],
          [39.101936, 21.643769],
          [39.102149, 21.643886],
          [39.10243, 21.644007],
          [39.102556, 21.644115],
          [39.102638, 21.64425],
          [39.102681, 21.644511],
          [39.102696, 21.644753],
          [39.102769, 21.645126],
          [39.102904, 21.645585],
          [39.102952, 21.646014],
          [39.102957, 21.646568],
          [39.102909, 21.647134],
          [39.102662, 21.649789],
          [39.102599, 21.649965],
          [39.102435, 21.650145],
          [39.102299, 21.650217],
          [39.102086, 21.650212],
          [39.101951, 21.650158],
          [39.101835, 21.650023],
          [39.101747, 21.649825],
          [39.101718, 21.649565],
          [39.101733, 21.649344],
          [39.101781, 21.649151],
          [39.101902, 21.648899],
          [39.102183, 21.648445],
          [39.102333, 21.648104],
          [39.102425, 21.647676],
          [39.102454, 21.647456],
          [39.102464, 21.647083],
          [39.10242, 21.646799],
          [39.102304, 21.646417],
          [39.102123, 21.646001],
          [39.10204, 21.645789],
          [39.102002, 21.645497],
          [39.101992, 21.645056],
          [39.101934, 21.644926],
          [39.101842, 21.644804],
          [39.101672, 21.644728],
          [39.101452, 21.644662],
          [39.101244, 21.644527],
          [39.101075, 21.644333],
          [39.100959, 21.644054],
          [39.100901, 21.643721],
          [39.100896, 21.643339],
          [39.100937, 21.642936],
          [39.101038, 21.642626],
          [39.101237, 21.642185],
          [39.101464, 21.641803],
          [39.101648, 21.641409],
          [39.10174, 21.641054],
          [39.101789, 21.640708],
          [39.101784, 21.640325],
          [39.101769, 21.639747],
          [39.101803, 21.639446],
          [39.101934, 21.639072],
          [39.102127, 21.638708],
          [39.102427, 21.638308],
          [39.102597, 21.638056],
          [39.102756, 21.637718],
          [39.102865, 21.637419],
          [39.102957, 21.637046],
          [39.102982, 21.636672],
          [39.102972, 21.636317],
          [39.102938, 21.635818],
          [39.102856, 21.635458],
          [39.102773, 21.635161],
          [39.102776, 21.63497],
          [39.102839, 21.634817],
          [39.102921, 21.63474],
          [39.103032, 21.634641],
          [39.103226, 21.63452],
          [39.103352, 21.634398],
          [39.103449, 21.634272],
          [39.10355, 21.633998],
          [39.103661, 21.633463],
          [39.103676, 21.633218],
          [39.103628, 21.633006],
          [39.103516, 21.63279],
          [39.102713, 21.631486],
          [39.102585, 21.631123],
          [39.102493, 21.630849],
          [39.102444, 21.630633],
          [39.102454, 21.630408],
          [39.102536, 21.629895],
          [39.102677, 21.629385],
          [39.102861, 21.628827],
          [39.103103, 21.628336],
          [39.103461, 21.627797],
          [39.103879, 21.627295],
          [39.104218, 21.626967],
          [39.1046, 21.626593],
          [39.105138, 21.626179],
          [39.105442, 21.625927],
          [39.105936, 21.6255],
          [39.106067, 21.625423],
          [39.106178, 21.625405],
          [39.106289, 21.625432],
          [39.106367, 21.625495],
          [39.106415, 21.625567],
          [39.10643, 21.625707],
          [39.10641, 21.625864],
          [39.105757, 21.628885],
          [39.10566, 21.629389],
          [39.105457, 21.630046],
          [39.105135, 21.631065]
        ]
      }
    }
  ]
});
